import angular from 'angular';
import _ from 'lodash';
import $ from 'jquery';
import template from './recruiterCandidatesJobView.html';
import Logger from '../../../shared/logger';
import { RECRUITER_WORKFLOW_STATUS } from '../constants/recruiter-workflow';
import { CANDIDATE_FEEDBACK_STATUSES } from '../constants/feedback';
import { LINK_TAG_REGEX } from '../../../constants/regex';
import './styles.scss';
import { EMPLOYER_WORKFLOW_STATUS } from '../../employer/constants/employer-workflow';
import { TALENTS_EXPLAIN_CHUNK_SIZE } from '../../search/searchController';
import { COUNTER_ALL, COUNTER_NON_RATED } from '../../common/tft-feedback-filter/component';
import { CONTACT_CANDIDATE_RESPONSE_OPTIONS } from '../../../constants/candidate';
import { CONTACT_MODE_TYPES, CONTACT_CHANNEL_TYPES } from '../constants/contactTypes';
import { ExplainInDetailsLevel } from '../../core/route/talentScoreService';
import { Recruiter } from '../../core/route/recruiterService';

export const DefaultFeedbackPageOptions = {
    page: 0,
    size: 20,
    skip: 0,
    total: 1,
};

export const WORKFLOW_STEPS = [
    {
        step: RECRUITER_WORKFLOW_STATUS.PROSPECT,
        labelKey: 'PROSPECTS',
    },
    {
        step: RECRUITER_WORKFLOW_STATUS.CLAIMED,
        labelKey: 'CLAIMED',
    },
    {
        step: RECRUITER_WORKFLOW_STATUS.ENGAGED,
        labelKey: 'ENGAGED',
    },
    {
        step: RECRUITER_WORKFLOW_STATUS.READY,
        labelKey: 'READY',
    },
    {
        step: RECRUITER_WORKFLOW_STATUS.SENT,
        labelKey: 'SENT',
    },
    {
        step: RECRUITER_WORKFLOW_STATUS.HIRED,
        labelKey: 'HIRED',
    },
    {
        step: RECRUITER_WORKFLOW_STATUS.REJECTED,
        labelKey: 'REJECTED_EMPLOYER',
    },
];

export class RecruiterCandidatesJobController {
    workflowSteps = WORKFLOW_STEPS;

    feedbackCounters = {};
    isSelectAllCheckboxVisible = false;
    feedbackFilterMode;

    feedbackFilterState = {
        selected: COUNTER_NON_RATED,
        counters: {
            all: 0,
            nonRated: 0,
            goodFit: 0,
            notFit: 0,
        },
    };
    feedbackListPageOptions = DefaultFeedbackPageOptions;
    canFetchMoreFeedbackCandidates = false;
    candidatesWithFeedback = [];

    /* @ngInject */
    constructor(
        $filter,
        $localStorage,
        $cacheFactory,
        $q,
        $scope,
        $sessionStorage,
        $state,
        $stateParams,
        $timeout,
        $uibModal,
        EmailService,
        permissions,
        CandidateApprovalService,
        CandidatesContactService,
        CandidateService,
        clipboard,
        CommonCodeService,
        EmployerRepService,
        EmployerService,
        EnvSettings,
        EMPLOYER_REP_AUTH_FLOW,
        MessageService,
        ModalDialogService,
        NotificationService,
        PositionEventsService,
        PositionService,
        RecruiterFeedbackService,
        RecruiterWorkflowStepResolver,
        RecruiterService,
        RouteService,
        searchCacheService,
        SearchService,
        TalentForEmployerService,
        TalentScoreService,
        TalentService,
        utils,
        WorkflowService,
        CampaignService,
        ImpersonationService,
        RecruiterCandidateService,
        EmployerFeedbackService,
        RecruiterCandidatesJobCacheService,
        $location,
        AuthService,
    ) {
        this.$state = $state;
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$localStorage = $localStorage;
        this.RecruiterFeedbackService = RecruiterFeedbackService;
        this.NotificationService = NotificationService;
        this.ModalDialogService = ModalDialogService;
        this.WorkflowService = WorkflowService;
        this.CampaignService = CampaignService;
        this.PositionService = PositionService;
        this.EmployerFeedbackService = EmployerFeedbackService;
        this.CandidateService = CandidateService;
        this.TalentScoreService = TalentScoreService;
        this.RecruiterCandidateService = RecruiterCandidateService;
        this.$uibModal = $uibModal;
        this.CONTACT_CHANNEL_TYPES = CONTACT_CHANNEL_TYPES;
        this.CONTACT_CANDIDATE_RESPONSE_OPTIONS = CONTACT_CANDIDATE_RESPONSE_OPTIONS;
        this.AuthService = AuthService;

        const recruiterCandidatesJobCtrl = this;

        recruiterCandidatesJobCtrl.init = function () {
            $(window)
                .scrollTop(0);

            $sessionStorage.previousState = null;

            recruiterCandidatesJobCtrl.cliamedLoading = true;

            recruiterCandidatesJobCtrl.sendEmployerFeedbackView = false;

            recruiterCandidatesJobCtrl.workflow = $stateParams.workflowStep;

            recruiterCandidatesJobCtrl.scroll = parseInt($stateParams.scroll);

            recruiterCandidatesJobCtrl.currentTalentID = $stateParams.talentID;

            const feedbackFilterMode = $location.search().feedbackFilterMode || $stateParams.feedbackFilterMode;

            recruiterCandidatesJobCtrl.feedbackFilterMode = feedbackFilterMode;
            recruiterCandidatesJobCtrl.feedbackFilterState = {
                selected: feedbackFilterMode || COUNTER_NON_RATED,
                counters: {
                    all: 0,
                    nonRated: 0,
                    goodFit: 0,
                    notFit: 0,
                },
            };

            recruiterCandidatesJobCtrl.currentRecruiterId = $stateParams.recruiterId;

            recruiterCandidatesJobCtrl.currentPage = parseInt($stateParams.currCandidatePage);

            recruiterCandidatesJobCtrl.criteriaFields = RouteService.getSystemPreference('searchCriteriaFields');

            recruiterCandidatesJobCtrl.maxTalentsToClaim = RouteService.getSystemDefaults('maxTalentsPerTalentExpertPosition');

            recruiterCandidatesJobCtrl.numberOfCandidatesToSearch = RouteService.getSystemDefaults('NumberOfCandidatesToSearch');

            recruiterCandidatesJobCtrl.sendingFeedbackPlaceholder = $filter('translate')('I_AM_SENDING_YOU_PROFILES_FOR_FEEDBACK');

            recruiterCandidatesJobCtrl.operationalEmailSender = RouteService.getSystemPreference('OperationalEmailSender');
            recruiterCandidatesJobCtrl.candidatesPerPage = RouteService.getSystemPreference('candidatesPerPage');
            recruiterCandidatesJobCtrl.feedbackListPageOptions.page = recruiterCandidatesJobCtrl.currentPage - 1;
            recruiterCandidatesJobCtrl.feedbackListPageOptions.size = recruiterCandidatesJobCtrl.candidatesPerPage;

            recruiterCandidatesJobCtrl.loadingPage = true;

            recruiterCandidatesJobCtrl.loadingFeedback = false;

            recruiterCandidatesJobCtrl.sendToEmployerDisabled = true;

            recruiterCandidatesJobCtrl.filteredCandidatesList = [];

            recruiterCandidatesJobCtrl.feedbackProviders = {};

            $sessionStorage.positionSearchName = null;

            RecruiterCandidatesJobCacheService.init($stateParams);

            recruiterCandidatesJobCtrl.canSendToEmployer = recruiterCandidatesJobCtrl.recruiterCtrl.talenyaUser ||
                (!recruiterCandidatesJobCtrl.recruiterCtrl.talenyaUser
                    && _.get(recruiterCandidatesJobCtrl, 'recruiterCtrl.recruiterData.roles', []).indexOf('request_feedback_from_employers') >= 0);

            $scope.getEmployerData = async () => {
                try {
                    const response = await EmployerService.getEmployer(recruiterCandidatesJobCtrl.positionData.employerId);
                    const employerData = _.get(response, 'result', {});

                    recruiterCandidatesJobCtrl.positionData.employerData = employerData;
                    recruiterCandidatesJobCtrl.positionData.employerData.locationString = CommonCodeService.getLocationString(_.get(employerData, 'locations.0'));
                } catch (error) {
                    Logger.error(error);
                }

                return recruiterCandidatesJobCtrl.positionData;
            };

            $scope.initSearch = function () {
                const selectedDesiredCandidateProfiles = recruiterCandidatesJobCtrl.positionData.desiredCandidateProfile.selected;

                _.forEach(recruiterCandidatesJobCtrl.criteriaFields, (criteriaField) => {
                    if (criteriaField.type === 'minMaxStatic') {
                        const minIndex = _.findIndex(selectedDesiredCandidateProfiles, { field: criteriaField.minField });
                        const maxIndex = _.findIndex(selectedDesiredCandidateProfiles, { field: criteriaField.maxField });

                        if (minIndex >= 0) {
                            criteriaField.minSelected = selectedDesiredCandidateProfiles[minIndex].items;
                        }
                        if (maxIndex >= 0) {
                            criteriaField.maxSelected = selectedDesiredCandidateProfiles[maxIndex].items;
                        }
                    } else {
                        const index = _.findIndex(selectedDesiredCandidateProfiles, { field: criteriaField.field });

                        if (index >= 0) {
                            criteriaField.selected = selectedDesiredCandidateProfiles[index].items;
                        }
                    }
                });

                searchCacheService.addSearch({
                    name: null,
                    fields: recruiterCandidatesJobCtrl.criteriaFields,
                }, -1);
                searchCacheService.saveSearchResult(1, null);
            };

            // TODO THIS PROCESS SHOULD BE REMOVED IN SCOPE OF REFACTORING, SEE https://talenya.atlassian.net/browse/TFT-1527
            $scope.getFeedbackData = async function (feedbackPage, callback) {
                recruiterCandidatesJobCtrl.minFeedbacksToSendToEmployer = RouteService.getSystemDefaults('minFeedbacksToSendToEmployer');
                recruiterCandidatesJobCtrl.maxFeedbacksToSendToEmployer = RouteService.getSystemDefaults('maxFeedbacksToSendToEmployer');

                try {
                    const {
                        positionData,
                        allWorkflows,
                        recruiters,
                        currentRecruiter,
                        allSamples,
                    } = await RecruiterCandidatesJobCacheService.getCustomData({ positionId: $stateParams.positionId });

                    const isPositionGdprCompliant = await PositionService.checkIfPositionIsGdprCompliant(positionData);
                    const isGdprIncludedOnEmployerLevel = _.get(recruiterCandidatesJobCtrl, 'positionData.employerData.settings.isGDPR');
                    recruiterCandidatesJobCtrl.isPositionGdprCompliant = isGdprIncludedOnEmployerLevel || isPositionGdprCompliant;

                    if (recruiterCandidatesJobCtrl?.isPositionGdprCompliant) {
                        recruiterCandidatesJobCtrl.gdprTooltip = `<span><div>${$filter('translate')('GDPR_LOCATION_ICON_TOOLTIP_TEXT')}</div></span>`;
                    }
                    recruiterCandidatesJobCtrl.currentRecruiter = currentRecruiter;

                    const feedbackProviders = await PositionService.getFeedbackProviders(positionData);

                    let feedbackWorkflows = _.filter(allWorkflows, (workflowData) => {
                        const requestFeedbackEvent = _.findIndex(workflowData.events, { eventType: WorkflowService.eventTypes.REQUEST_FEEDBACK });
                        const backToProspects = _.findIndex(workflowData.events, { eventType: WorkflowService.eventTypes.BLOCK_REQUEST_FEEDBACK });

                        const isProspect = !(requestFeedbackEvent >= 0 && (backToProspects < 0 || requestFeedbackEvent < backToProspects));
                        return !isProspect;
                    });
                    const allFeedBackWorkflows = feedbackWorkflows.length;
                    feedbackWorkflows = _.map(feedbackWorkflows, (feedbackWorkflow) => {
                        const index = _.findIndex(positionData.feedbackOnCandidates, feedback =>
                            (feedback.status && feedback.candidateId === feedbackWorkflow.candidateId));
                        if (index >= 0) {
                            feedbackWorkflow.feedback = positionData.feedbackOnCandidates[index];
                            const feedbackStatus = _.get(feedbackWorkflow, 'feedback.status', null);
                            if (WorkflowService.isFeedbackFromEmployerExists(feedbackStatus)) {
                                const feedbackProviderId = feedbackWorkflow.feedback.employerRepId;
                                feedbackWorkflow.feedback.feedbackProviderName = feedbackProviders[feedbackProviderId];
                            }
                            return feedbackWorkflow;
                        }

                        return {
                            ...feedbackWorkflow,
                            feedback: { status: CANDIDATE_FEEDBACK_STATUSES.READY_FOR_SEND },
                        };
                    });
                    const readyForSendFeedbackCount = (_.countBy(feedbackWorkflows, feedbackWorkflow =>
                        feedbackWorkflow.feedback && feedbackWorkflow.feedback.status === CANDIDATE_FEEDBACK_STATUSES.READY_FOR_SEND).true || 0);
                    const feedbackStatusExist = (_.countBy(feedbackWorkflows, feedbackWorkflow =>
                        feedbackWorkflow.feedback && feedbackWorkflow.feedback.status !== CANDIDATE_FEEDBACK_STATUSES.READY_FOR_SEND).true || 0) > 0;
                    const feedbackAcceptedCount = (_.countBy(feedbackWorkflows, feedbackWorkflow =>
                        feedbackWorkflow.feedback && feedbackWorkflow.feedback.status === CANDIDATE_FEEDBACK_STATUSES.ACCEPTED).true || 0);
                    const feedbackPendingCount = (_.countBy(feedbackWorkflows, feedbackWorkflow =>
                        feedbackWorkflow.feedback && feedbackWorkflow.feedback.status === CANDIDATE_FEEDBACK_STATUSES.PENDING).true || 0);

                    recruiterCandidatesJobCtrl.feedbackStatusExist = feedbackStatusExist;
                    recruiterCandidatesJobCtrl.feedbackAcceptedCount = feedbackAcceptedCount;
                    recruiterCandidatesJobCtrl.allFeedBackWorkflows = allFeedBackWorkflows;
                    recruiterCandidatesJobCtrl.readyForSendFeedbackCount = readyForSendFeedbackCount;
                    recruiterCandidatesJobCtrl.feedbackPendingCount = feedbackPendingCount;
                    $timeout(() => {
                        recruiterCandidatesJobCtrl.feedbackStatusExist = feedbackStatusExist;
                        recruiterCandidatesJobCtrl.feedbackAcceptedCount = feedbackAcceptedCount;
                        recruiterCandidatesJobCtrl.allFeedBackWorkflows = allFeedBackWorkflows;
                        recruiterCandidatesJobCtrl.readyForSendFeedback = readyForSendFeedbackCount;
                        recruiterCandidatesJobCtrl.feedbackPendingCount = feedbackPendingCount;
                        recruiterCandidatesJobCtrl.feedbackCounters = {
                            feedbackStatusExist,
                            feedbackAcceptedCount,
                            allFeedBackWorkflows,
                            readyForSendFeedbackCount,
                            feedbackPendingCount,
                        };
                    });

                    if (!feedbackPage) {
                        $timeout(() => callback());
                        return;
                    }

                    recruiterCandidatesJobCtrl.fetchCanGenerateAutoFeedback();

                    const unselectedSamples = (allSamples || []).filter(({ selected }) => (!selected));

                    recruiterCandidatesJobCtrl.recruiters = recruiters;
                    recruiterCandidatesJobCtrl.allSamples = allSamples;
                    recruiterCandidatesJobCtrl.unselectedSamples = unselectedSamples;

                    const translate = $filter('translate');

                    if (!PositionEventsService.isSendFeedbackToEmployerAvailable(positionData)) {
                        recruiterCandidatesJobCtrl.sendToEmployerDisabled = true;
                        recruiterCandidatesJobCtrl.sendToEmployerButtonDisabledTooltip = translate('FEEDBACK_BUTTON_DISABLED_TOOLTIP');
                    } else if (feedbackStatusExist) {
                        recruiterCandidatesJobCtrl.sendToEmployerDisabled = false;
                    } else {
                        const max = recruiterCandidatesJobCtrl.maxFeedbacksToSendToEmployer;
                        const min = recruiterCandidatesJobCtrl.minFeedbacksToSendToEmployer;
                        const workflowsLength = feedbackWorkflows.length;

                        recruiterCandidatesJobCtrl.sendToEmployerDisabled = workflowsLength > max || workflowsLength < min;

                        if (workflowsLength < min) {
                            recruiterCandidatesJobCtrl.sendToEmployerButtonDisabledTooltip = translate('PLEASE_SEND_AT_LEAST_NUMBER_PROFILE', {
                                minNumberOfProfiles: min,
                            });
                        } else if (workflowsLength > max) {
                            recruiterCandidatesJobCtrl.sendToEmployerButtonDisabledTooltip = translate('YOU_CAN_ONLY_SEND_BATCH_OF_MAX_NUMBER_PROFILES', {
                                maxNumberOfProfiles: max,
                            });
                        }
                    }

                    recruiterCandidatesJobCtrl.positionData.workflowData.requestFeedback.added.resultList = [];

                    await recruiterCandidatesJobCtrl.fetchFeedbackCandidatesMore(
                        recruiterCandidatesJobCtrl.feedbackListPageOptions,
                        recruiterCandidatesJobCtrl.feedbackFilterState,
                    );

                    const { positionId } = recruiterCandidatesJobCtrl.$stateParams;
                    const { result: manuallyAddedSamples } = await RecruiterCandidatesJobCacheService.getSelectedAndFeedbackAndManuallyAddedSamples({
                        positionId,
                        options: {
                            populateData: true,
                            exposeDetails: true,
                            useExplain: true,
                        },
                    });

                    recruiterCandidatesJobCtrl.manuallyAddedSamples = manuallyAddedSamples.map(sampleData =>
                        recruiterCandidatesJobCtrl.EmployerFeedbackService.getPreparedCandidate({
                            ...sampleData.candidateData,
                            sample: {
                                ...sampleData,
                                candidateData: undefined,
                            },
                        }, sampleData.candidateData),
                    );

                    const noFeedbackProfiles = recruiterCandidatesJobCtrl.positionData.workflowData.requestFeedback.added.resultListLength === 0;
                    const areSamplesProfilesExist = recruiterCandidatesJobCtrl.manuallyAddedSamples.length > 0;

                    recruiterCandidatesJobCtrl.noFeedbackProfiles = noFeedbackProfiles;
                    recruiterCandidatesJobCtrl.areSamplesProfilesExist = areSamplesProfilesExist;

                    const isRedirectToSamples = $stateParams.isFeedbackToSamplesRedirectIfEmpty
                        && $stateParams.workflowStep === RECRUITER_WORKFLOW_STATUS.FEEDBACK
                        && noFeedbackProfiles
                        && areSamplesProfilesExist;

                    if (isRedirectToSamples) {
                        recruiterCandidatesJobCtrl.onShowSamplesButtonClick();
                    }

                    $stateParams.isFeedbackToSamplesRedirectIfEmpty = true;
                    recruiterCandidatesJobCtrl.filteredCandidatesList = recruiterCandidatesJobCtrl.getFilteredCandidatesList();
                    recruiterCandidatesJobCtrl.isSelectAllCheckboxVisible = recruiterCandidatesJobCtrl.filteredCandidatesList.length > 0;

                    $scope.$apply();
                    $timeout(() => callback());
                } catch (error) {
                    Logger.error(error);
                } finally {
                    recruiterCandidatesJobCtrl.loadingFeedback = false;
                }
            };

            // TODO THIS PROCESS SHOULD BE REMOVED IN SCOPE OF REFACTORING, SEE https://talenya.atlassian.net/browse/TFT-1527
            $scope.getCandidates = async function () {
                try {
                    let talentIds = [];
                    const isCandidateProfileOpen = $stateParams.talentID;

                    for (let i = (recruiterCandidatesJobCtrl.currentPage - 1) * recruiterCandidatesJobCtrl.candidatesPerPage;
                        i < recruiterCandidatesJobCtrl.currentPage * recruiterCandidatesJobCtrl.candidatesPerPage; i++) {
                        if (i >= recruiterCandidatesJobCtrl.positionData.workflowData.candidates.resultList.length || i < 0) {
                            break;
                        }

                        talentIds.push(recruiterCandidatesJobCtrl.positionData.workflowData.candidates.resultList[i].talentID);
                    }

                    if (isCandidateProfileOpen) {
                        const index = talentIds.indexOf($stateParams.talentID);

                        if (index >= 0) {
                            talentIds = [talentIds[index]];
                        }
                    }

                    if (talentIds.length > 0) {
                        const workflows = recruiterCandidatesJobCtrl.positionData.workflowData.data;
                        const workflowIds = (workflows || []).map(workflow => workflow._id);

                        const [
                            { result: talents },
                            allSamples,
                            { result: employerWorkflowStatuses },
                            { result: campaignStatuses },
                        ] = await Promise.all([
                            TalentService.postTalents({ talentIDs: talentIds, isListView: !isCandidateProfileOpen }),
                            PositionService.getSelectedAndFeedbackAndManuallyAddedSamples($stateParams.positionId),
                            WorkflowService.getCandidatesEmployerWorkflowStatus($stateParams.positionId, workflowIds),
                            CampaignService.getCampaignCandidatesStatus($stateParams.positionId, workflowIds),
                        ]);
                        const unselectedSamples = (allSamples || []).filter(({ selected }) => (!selected));

                        for (let i = 0; i < talents.length; i++) {
                            const candidate = _.find(recruiterCandidatesJobCtrl.positionData.workflowData.candidates.resultList, {
                                talentID: talents[i].talentId,
                            });

                            if (candidate) {
                                const employerWorkflowStatusData = employerWorkflowStatuses.find(({ talentId }) => talentId === candidate.talentID);
                                const campaignStatus = campaignStatuses.find(({ talentId }) => talentId === candidate.talentID);
                                const employerWorkflowStatus = _.get(employerWorkflowStatusData, 'status', EMPLOYER_WORKFLOW_STATUS.NONE);

                                candidate.workflow = RecruiterCandidateService.getCandidateWorkflow(
                                    candidate,
                                    workflows,
                                    recruiterCandidatesJobCtrl.positionData,
                                );
                                candidate.campaignStatus = campaignStatus;
                                candidate.isAutoContact = !!_.get(campaignStatus, 'candidateCampaignId');
                                candidate.workflow.employerWorkflowStatus = employerWorkflowStatus;
                                candidate.candidateData = talents[i];
                                candidate.fullName = candidate.candidateData.name;
                                candidate.candidateData.matchScore = candidate.matchScore;
                                candidate.currentJob = _.find(candidate.candidateData.employmentHistory, { isCurrent: true });
                                candidate.previousJob = _.find(candidate.candidateData.employmentHistory, { isCurrent: false });
                                candidate.predictionScore = candidate.candidateData.predictionScore;
                                candidate.residency = CommonCodeService.getLocationString(candidate.candidateData.residency);
                                candidate.sample = (allSamples || []).find(({ talentId }) => talentId === candidate.talentID);
                                candidate.unselectedSample = unselectedSamples.find(({ talentId }) => talentId === candidate.talentID);
                                candidate.employerWorkflowStatus = employerWorkflowStatuses.find(({ talentId }) => talentId === candidate.talentID);
                            }
                        }

                        recruiterCandidatesJobCtrl.populateCandidatesWithExplain(talentIds);

                        recruiterCandidatesJobCtrl.positionData.workflowData.candidates.resultListLength =
                            recruiterCandidatesJobCtrl.positionData.workflowData.candidates.resultList.length;
                        recruiterCandidatesJobCtrl.loadingPage = false;
                    }
                } catch (error) {
                    Logger.error(error);
                }

                $scope.$apply();
            };

            // TODO THIS PROCESS SHOULD BE REMOVED IN SCOPE OF REFACTORING, SEE https://talenya.atlassian.net/browse/TFT-1527
            $scope.getWorkflows = async function () {
                try {
                    const [
                        response = { result: [] },
                        feedbackProviders,
                    ] = await Promise.all([
                        WorkflowService.getWorkflowSearch({
                            positionId: $stateParams.positionId,
                        }),
                        PositionService.getFeedbackProviders(recruiterCandidatesJobCtrl.positionData),
                    ]);

                    recruiterCandidatesJobCtrl.feedbackProviders = feedbackProviders;

                    response.result = _.reduce(response.result, (accumulator, workflow) => {
                        const isDuplicateWorkflow = _.findIndex(accumulator, w => w.talentId === workflow.talentId) !== -1;

                        if (!isDuplicateWorkflow && workflow.recruiterStatus.current !== 'Prospect') {
                            if (recruiterCandidatesJobCtrl.positionData && recruiterCandidatesJobCtrl.positionData.feedbackOnCandidates) {
                                const index = _.findIndex(
                                    recruiterCandidatesJobCtrl.positionData.feedbackOnCandidates,
                                    { candidateId: workflow.candidateId },
                                );
                                if (index >= 0) {
                                    workflow.feedback = recruiterCandidatesJobCtrl.positionData.feedbackOnCandidates[index];
                                    if (WorkflowService.isFeedbackFromEmployerExists(_.get(workflow, 'feedback.status', null))) {
                                        const feedbackProviderId = workflow.feedback.employerRepId;
                                        // eslint-disable-next-line max-len
                                        workflow.feedback.feedbackProviderName = feedbackProviders[feedbackProviderId];
                                    }
                                }
                            }
                            return [...accumulator, workflow];
                        }
                        return accumulator;
                    }, []);

                    if (recruiterCandidatesJobCtrl.positionData) {
                        recruiterCandidatesJobCtrl.positionData.workflowData = {
                            candidates: {
                                resultList: [],
                                resultListLength: 0,
                            },
                            requestFeedback: {
                                added: {
                                    resultList: [],
                                    resultListLength: 0,
                                },
                            },
                            data: response.result,
                        };
                        for (let i = 0; i < response.result.length; i++) {
                            if (response.result[i].recruiterStatus.current === recruiterCandidatesJobCtrl.workflow) {
                                recruiterCandidatesJobCtrl.positionData.workflowData.candidates.resultList.push({
                                    talentID: response.result[i].talentId,
                                });
                            }
                        }
                        recruiterCandidatesJobCtrl.positionData.workflowData.candidates.resultListLength =
                            recruiterCandidatesJobCtrl.positionData.workflowData.candidates.resultList.length;
                        if (recruiterCandidatesJobCtrl.positionData.workflowData.candidates.resultList.length > 0) {
                            $scope.getCandidates();
                        } else {
                            recruiterCandidatesJobCtrl.loadingPage = false;
                        }
                    }
                } catch (error) {
                    Logger.error(error);
                }
            };

            $scope.getPosition = async () => {
                try {
                    const response = await PositionService.getPosition($stateParams.positionId);

                    if (response) {
                        const positionData = response.result;
                        recruiterCandidatesJobCtrl.positionData = positionData;
                        recruiterCandidatesJobCtrl.positionData.locationData = CommonCodeService.getLocationData(positionData);
                        recruiterCandidatesJobCtrl.positionData.desiredCandidateProfile.maxItems = 100;
                        $scope.initSearch();
                        $localStorage.criteriaFields = recruiterCandidatesJobCtrl.criteriaFields;

                        await Promise.all([
                            $scope.getEmployerData(),
                            $scope.getWorkflows(),
                        ]);
                        $scope.$apply();
                    }
                } catch (error) {
                    Logger.error(error);
                }
            };

            $scope.getPosition();
        };

        recruiterCandidatesJobCtrl.populateCandidatesWithExplain = async (
            talentIds,
            explainInDetailsLevel = ExplainInDetailsLevel.minimalWithSkills,
        ) => {
            const chunkedTalentIds = _.chunk(talentIds, TALENTS_EXPLAIN_CHUNK_SIZE);
            const promises = [];
            const isProfileView = !!recruiterCandidatesJobCtrl.currentTalentID;

            const filter = {
                ...recruiterCandidatesJobCtrl.positionData.desiredCandidateProfile,
                cascadingSearch: true,
                explainInDetails: isProfileView ? ExplainInDetailsLevel.full : explainInDetailsLevel,
            };

            for (const oneChunk of chunkedTalentIds) {
                promises.push(TalentScoreService.postTalentExplainScore({
                    filter,
                    talentIDs: oneChunk,
                }).then(({ result: talentExplains = [] }) => {
                    recruiterCandidatesJobCtrl.positionData.workflowData.candidates.resultList =
                        CandidateService.addExplainsDataToCandidates({
                            candidates: recruiterCandidatesJobCtrl.positionData.workflowData.candidates.resultList,
                            talentExplains,
                        });

                    recruiterCandidatesJobCtrl.positionData.workflowData.candidates.resultList.forEach(
                        candidate => oneChunk.includes(candidate.talentId || candidate.talentID) && (candidate.isExplainLoading = false),
                    );
                }));
            }

            await Promise.all(promises);

            $scope.$apply();
        };

        recruiterCandidatesJobCtrl.initSearchData = function () {
            recruiterCandidatesJobCtrl.filteredCandidatesLength = {
                value: 0,
            };
            return {
                currSearchHistoryIndex: 1,
                currCandidatePage: recruiterCandidatesJobCtrl.currentPage,
                talentID: recruiterCandidatesJobCtrl.currentTalentID,
                feedbackFilterMode: recruiterCandidatesJobCtrl.feedbackFilterMode,
                scroll: recruiterCandidatesJobCtrl.scroll,
                searchName: null,
                showView: 'customSearch',
                showResults: (recruiterCandidatesJobCtrl.numberOfCandidatesToSearch || 400) + parseInt($stateParams.claimedByOtherTE || 0),
                prospectsCandidates: 0,
                htmlView: 'components/recruiter/recruiterCandidatesJob/recruiterCandidatesJobSearchView.html',
                recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                positionId: recruiterCandidatesJobCtrl.positionData._id,
                rejectCandidate: recruiterCandidatesJobCtrl.rejectCandidate,
                addNote: recruiterCandidatesJobCtrl.addNote,
                getNotes: recruiterCandidatesJobCtrl.getNotesAndComments,
                backToPreviousStatus: recruiterCandidatesJobCtrl.backToPreviousStatus,
                moveStatusEmployerTo: recruiterCandidatesJobCtrl.moveStatusEmployerTo,
                showHidden: $stateParams.showHidden,
                contactCandidate: recruiterCandidatesJobCtrl.contactCandidate,
                isContactFormLoading: recruiterCandidatesJobCtrl.isContactFormLoading,
                sendMsg: recruiterCandidatesJobCtrl.sendMsg,
                sendLinkedinMessageToCandidate: recruiterCandidatesJobCtrl.sendLinkedinMessageToCandidate,
                remainingPositions: recruiterCandidatesJobCtrl.positionData.remainingPositions,
                positionData: recruiterCandidatesJobCtrl.positionData,
                desiredCandidateProfile: recruiterCandidatesJobCtrl.positionData.desiredCandidateProfile,
                backToProspects: recruiterCandidatesJobCtrl.backToProspects,
                updateInterview: recruiterCandidatesJobCtrl.updateInterview,
                feedbackStatusExist: recruiterCandidatesJobCtrl.feedbackStatusExist,
                initActivityTab: recruiterCandidatesJobCtrl.initActivityTab,
                multiBackToProspect: recruiterCandidatesJobCtrl.multiBackToProspect,
                multiRejectCandidates: recruiterCandidatesJobCtrl.multiRejectCandidates.bind(recruiterCandidatesJobCtrl),
                canSendToEmployer: (recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.roles || []).includes('request_feedback_from_employers'),
                contactUser: recruiterCandidatesJobCtrl.contactUser,
                changeTemplateTags: recruiterCandidatesJobCtrl.changeTemplateTags,
                filteredCandidatesLength: recruiterCandidatesJobCtrl.filteredCandidatesLength,
                requestFeedback: recruiterCandidatesJobCtrl.requestFeedback.bind(recruiterCandidatesJobCtrl),
                removeCandidateFromFeedback: recruiterCandidatesJobCtrl.removeCandidateFromFeedback.bind(recruiterCandidatesJobCtrl),
                multiRequestFeedback: recruiterCandidatesJobCtrl.multiRequestFeedback.bind(recruiterCandidatesJobCtrl),
                multiRemoveRequestFeedback: recruiterCandidatesJobCtrl.multiRemoveRequestFeedback.bind(recruiterCandidatesJobCtrl),
                showConfirmErrorEmailMessage: recruiterCandidatesJobCtrl.showConfirmErrorEmailMessage.bind(recruiterCandidatesJobCtrl),
            };
        };

        recruiterCandidatesJobCtrl.initProspects = function () {
            recruiterCandidatesJobCtrl.loadingFeedback = true;
            $scope.getFeedbackData(false, () => {
                recruiterCandidatesJobCtrl.prospectsData = recruiterCandidatesJobCtrl.initSearchData();
                recruiterCandidatesJobCtrl.prospectsData.currSearchHistoryIndex = 1;
                recruiterCandidatesJobCtrl.prospectsData.claimCandidate = recruiterCandidatesJobCtrl.claimCandidate;
                recruiterCandidatesJobCtrl.prospectsData.bulkClaimCandidates = recruiterCandidatesJobCtrl.bulkClaimCandidates;
                recruiterCandidatesJobCtrl.prospectsData.hideCandidate = recruiterCandidatesJobCtrl.hideCandidate;
                recruiterCandidatesJobCtrl.prospectsData.workFlowStatus = undefined;
                recruiterCandidatesJobCtrl.prospectsData.positionData = recruiterCandidatesJobCtrl.positionData;
                recruiterCandidatesJobCtrl.prospectsData.backButtonText = 'PROSPECTS';
                recruiterCandidatesJobCtrl.prospectsData.desiredCandidateProfile = recruiterCandidatesJobCtrl.positionData.desiredCandidateProfile;
                recruiterCandidatesJobCtrl.prospectsData.refreshSearch = recruiterCandidatesJobCtrl.refreshSearch;
                recruiterCandidatesJobCtrl.prospectsData.moveProspectToReady = recruiterCandidatesJobCtrl.moveProspectToReady;
                recruiterCandidatesJobCtrl.loadingFeedback = false;
            });
        };

        recruiterCandidatesJobCtrl.initClaim = function () {
            recruiterCandidatesJobCtrl.loadingFeedback = true;
            $scope.getFeedbackData(false, () => {
                recruiterCandidatesJobCtrl.cliamedData = recruiterCandidatesJobCtrl.initSearchData();
                recruiterCandidatesJobCtrl.cliamedData.workFlowStatus = RECRUITER_WORKFLOW_STATUS.CLAIMED;
                recruiterCandidatesJobCtrl.cliamedData.backButtonText = 'CLAIMED';
                recruiterCandidatesJobCtrl.cliamedData.candidates = recruiterCandidatesJobCtrl.positionData.workflowData.candidates;
                recruiterCandidatesJobCtrl.cliamedData.interviewCandidate = recruiterCandidatesJobCtrl.interviewCandidate;
                recruiterCandidatesJobCtrl.loadingFeedback = false;
            });
        };

        recruiterCandidatesJobCtrl.initEngaged = function () {
            recruiterCandidatesJobCtrl.loadingFeedback = true;
            $scope.getFeedbackData(false, () => {
                recruiterCandidatesJobCtrl.engagedData = recruiterCandidatesJobCtrl.initSearchData();
                recruiterCandidatesJobCtrl.engagedData.workFlowStatus = RECRUITER_WORKFLOW_STATUS.ENGAGED;
                recruiterCandidatesJobCtrl.engagedData.backButtonText = 'ENGAGED';
                recruiterCandidatesJobCtrl.engagedData.events = recruiterCandidatesJobCtrl.positionData.workflowData.events;
                recruiterCandidatesJobCtrl.engagedData.candidates = recruiterCandidatesJobCtrl.positionData.workflowData.candidates;
                recruiterCandidatesJobCtrl.engagedData.createResumeForEmployer = recruiterCandidatesJobCtrl.createResumeForEmployer;
                recruiterCandidatesJobCtrl.engagedData.approveSubmission = recruiterCandidatesJobCtrl.approveSubmission;
                recruiterCandidatesJobCtrl.engagedData.interviewCandidate = recruiterCandidatesJobCtrl.interviewCandidate;
                recruiterCandidatesJobCtrl.engagedData.sendResumeToCandidate = recruiterCandidatesJobCtrl.sendResumeToCandidate;
                recruiterCandidatesJobCtrl.engagedData.createResume = recruiterCandidatesJobCtrl.createResume;
                recruiterCandidatesJobCtrl.loadingFeedback = false;
            });
        };

        recruiterCandidatesJobCtrl.initReady = function () {
            recruiterCandidatesJobCtrl.loadingFeedback = true;
            $scope.getFeedbackData(false, () => {
                recruiterCandidatesJobCtrl.readyData = recruiterCandidatesJobCtrl.initSearchData();
                recruiterCandidatesJobCtrl.readyData.workFlowStatus = RECRUITER_WORKFLOW_STATUS.READY;
                recruiterCandidatesJobCtrl.readyData.backButtonText = 'READY';
                recruiterCandidatesJobCtrl.readyData.employerEmails = _.map(recruiterCandidatesJobCtrl.positionData.employerData.contact.email, 'value');
                recruiterCandidatesJobCtrl.readyData.candidates = recruiterCandidatesJobCtrl.positionData.workflowData.candidates;
                recruiterCandidatesJobCtrl.readyData.multiSendResumeToEmployer = recruiterCandidatesJobCtrl.multiSendResumeToEmployer;
                recruiterCandidatesJobCtrl.readyData.sendResumeToEmployer = recruiterCandidatesJobCtrl.sendResumeToEmployer;
                recruiterCandidatesJobCtrl.readyData.copyLinkToClipboard = recruiterCandidatesJobCtrl.copyLinkToClipboard;
                recruiterCandidatesJobCtrl.loadingFeedback = false;
            });
        };

        recruiterCandidatesJobCtrl.initSent = function () {
            recruiterCandidatesJobCtrl.loadingFeedback = true;
            $scope.getFeedbackData(false, () => {
                recruiterCandidatesJobCtrl.sentData = recruiterCandidatesJobCtrl.initSearchData();
                recruiterCandidatesJobCtrl.sentData.workFlowStatus = RECRUITER_WORKFLOW_STATUS.SENT;
                recruiterCandidatesJobCtrl.sentData.backButtonText = 'SENT';
                recruiterCandidatesJobCtrl.sentData.employerLink = `${EnvSettings.Auth0RedirectUrl
                }#/employer/${recruiterCandidatesJobCtrl.positionData.employerId}/candidatesJob/${recruiterCandidatesJobCtrl.positionData._id}/` +
                    'workflowStep/Prospect/candidatesPage/1/scroll/0/candidate/';
                recruiterCandidatesJobCtrl.sentData.candidates = recruiterCandidatesJobCtrl.positionData.workflowData.candidates;
                recruiterCandidatesJobCtrl.loadingFeedback = false;
            });
        };

        recruiterCandidatesJobCtrl.initHired = function () {
            recruiterCandidatesJobCtrl.loadingFeedback = true;
            $scope.getFeedbackData(false, () => {
                recruiterCandidatesJobCtrl.hiredData = recruiterCandidatesJobCtrl.initSearchData();
                recruiterCandidatesJobCtrl.hiredData.workFlowStatus = RECRUITER_WORKFLOW_STATUS.HIRED;
                recruiterCandidatesJobCtrl.hiredData.backButtonText = 'HIRED';
                recruiterCandidatesJobCtrl.hiredData.candidates = recruiterCandidatesJobCtrl.positionData.workflowData.candidates;
                recruiterCandidatesJobCtrl.loadingFeedback = false;
            });
        };

        recruiterCandidatesJobCtrl.initRejected = function () {
            recruiterCandidatesJobCtrl.loadingFeedback = true;
            $scope.getFeedbackData(false, () => {
                recruiterCandidatesJobCtrl.rejectedData = recruiterCandidatesJobCtrl.initSearchData();
                recruiterCandidatesJobCtrl.rejectedData.workFlowStatus = RECRUITER_WORKFLOW_STATUS.REJECTED;
                recruiterCandidatesJobCtrl.rejectedData.backButtonText = 'REJECTED';
                recruiterCandidatesJobCtrl.rejectedData.candidates = recruiterCandidatesJobCtrl.positionData.workflowData.candidates;
                recruiterCandidatesJobCtrl.rejectedData.backToPreviousStatusRejected = recruiterCandidatesJobCtrl.backToPreviousStatusRejected;
                recruiterCandidatesJobCtrl.loadingFeedback = false;
            });
        };

        recruiterCandidatesJobCtrl.initFeedback = function () {
            return new Promise((resolve) => {
                $scope.getFeedbackData(true, () => {
                    recruiterCandidatesJobCtrl.feedBackErrorMessage = null;
                    recruiterCandidatesJobCtrl.sendEmployerFeedbackView = true;
                    recruiterCandidatesJobCtrl.feedbackData = recruiterCandidatesJobCtrl.initSearchData();
                    recruiterCandidatesJobCtrl.feedbackData.manuallyAddedSamples = recruiterCandidatesJobCtrl.manuallyAddedSamples;
                    recruiterCandidatesJobCtrl.feedbackData.workFlowStatus = RECRUITER_WORKFLOW_STATUS.FEEDBACK;
                    recruiterCandidatesJobCtrl.feedbackData.backButtonText = 'FEEDBACK';
                    recruiterCandidatesJobCtrl.feedbackData.workflowData = recruiterCandidatesJobCtrl.positionData.workflowData;
                    recruiterCandidatesJobCtrl.feedbackData.candidates = recruiterCandidatesJobCtrl.positionData.workflowData.requestFeedback.added;
                    recruiterCandidatesJobCtrl.feedbackData.backToPreviousStatusRejected = recruiterCandidatesJobCtrl.backToPreviousStatusRejected;
                    recruiterCandidatesJobCtrl.feedbackData.events = recruiterCandidatesJobCtrl.positionData.workflowData.events;
                    recruiterCandidatesJobCtrl.feedbackData.createResumeForEmployer = recruiterCandidatesJobCtrl.createResumeForEmployer;
                    recruiterCandidatesJobCtrl.feedbackData.approveSubmission = recruiterCandidatesJobCtrl.approveSubmission;
                    recruiterCandidatesJobCtrl.feedbackData.interviewCandidate = recruiterCandidatesJobCtrl.interviewCandidate;
                    recruiterCandidatesJobCtrl.feedbackData.sendResumeToCandidate = recruiterCandidatesJobCtrl.sendResumeToCandidate;
                    recruiterCandidatesJobCtrl.feedbackData.createResume = recruiterCandidatesJobCtrl.createResume;
                    recruiterCandidatesJobCtrl.feedbackData.desiredCandidateProfile = recruiterCandidatesJobCtrl.positionData.desiredCandidateProfile;
                    recruiterCandidatesJobCtrl.feedbackData.claimCandidate = recruiterCandidatesJobCtrl.claimCandidate;
                    recruiterCandidatesJobCtrl.feedbackData.hideCandidate = recruiterCandidatesJobCtrl.hideCandidate;
                    recruiterCandidatesJobCtrl.feedbackData.multiSendResumeToEmployer = recruiterCandidatesJobCtrl.multiSendResumeToEmployer;
                    recruiterCandidatesJobCtrl.feedbackData.sendResumeToEmployer = recruiterCandidatesJobCtrl.sendResumeToEmployer;
                    recruiterCandidatesJobCtrl.feedbackData.copyLinkToClipboard = recruiterCandidatesJobCtrl.copyLinkToClipboard;
                    recruiterCandidatesJobCtrl.feedbackData.employerEmails = _.map(recruiterCandidatesJobCtrl.positionData.employerData.contact.email, 'value');
                    recruiterCandidatesJobCtrl.feedbackData.employerLink =
                        `${EnvSettings.Auth0RedirectUrl}#/employer/${recruiterCandidatesJobCtrl.positionData.employerId}/candidatesJob/${recruiterCandidatesJobCtrl.positionData._id}/workflowStep/Prospect/candidatesPage/1/scroll/0/candidate/`;
                    recruiterCandidatesJobCtrl.feedbackData.backToPreviousStatusRejected = recruiterCandidatesJobCtrl.backToPreviousStatusRejected;
                    recruiterCandidatesJobCtrl.feedbackData.feedbackListPageOptions = recruiterCandidatesJobCtrl.feedbackListPageOptions;
                    recruiterCandidatesJobCtrl.feedbackData.feedbackFilterState = recruiterCandidatesJobCtrl.feedbackFilterState;
                    // eslint-disable-next-line max-len
                    recruiterCandidatesJobCtrl.feedbackData.fetchFeedbackCandidatesMore = recruiterCandidatesJobCtrl.fetchFeedbackCandidatesMore.bind(this);

                    resolve();
                });
            });
        };

        recruiterCandidatesJobCtrl.initSamples = async () => {
            await recruiterCandidatesJobCtrl.initFeedback();

            recruiterCandidatesJobCtrl.feedbackData.backButtonText = 'SAMPLES';
        };

        recruiterCandidatesJobCtrl.openSearch = function () {
            $sessionStorage.searchExplainScore = null;
            PositionService.getPosition($stateParams.positionId)
                .then((response) => {
                    const positionData = response.result;

                    searchCacheService.addSearch({
                        name: null,
                        fields: RouteService.getSystemPreference('searchCriteriaFields'),
                    }, -1);

                    searchCacheService.addSearch({
                        name: `Position ${positionData.jobTitle}`,
                        fields: recruiterCandidatesJobCtrl.criteriaFields,
                    }, 0);

                    searchCacheService.saveSearchResult(1, null);
                    $sessionStorage.previousState = {
                        state: $state.current.name,
                        params: angular.copy($stateParams),
                    };
                    $sessionStorage.positionSearchName = {
                        name: `Position ${positionData.jobTitle}`,
                        criteria: recruiterCandidatesJobCtrl.criteriaFields,
                    };
                    $state.go('recruiter.search', {
                        recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                        positionId: positionData._id,
                        currSearchHistoryIndex: 1,
                        currCandidatePage: 1,
                        talentID: null,
                        scroll: 0,
                        searchName: null,
                    });
                })
                .catch(error => Logger.error(error));
        };

        recruiterCandidatesJobCtrl.openNewSearch = function () {
            $sessionStorage.searchExplainScore = null;
            PositionService.getPosition($stateParams.positionId)
                .then((response) => {
                    const positionData = response.result;

                    searchCacheService.addSearch({
                        name: null,
                        fields: RouteService.getSystemPreference('searchCriteriaFields'),
                    }, -1);

                    searchCacheService.addSearch({
                        name: `Position ${positionData.jobTitle}`,
                        fields: recruiterCandidatesJobCtrl.criteriaFields,
                    }, 0);

                    searchCacheService.saveSearchResult(1, null);
                    $sessionStorage.previousState = {
                        state: $state.current.name,
                        params: angular.copy($stateParams),
                    };
                    $sessionStorage.positionSearchName = {
                        name: `Position ${positionData.jobTitle}`,
                        criteria: recruiterCandidatesJobCtrl.criteriaFields,
                    };
                    $state.go('recruiter.searchNew', {
                        recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                        positionId: positionData._id,
                        history: 1,
                        page: 1,
                        talentID: null,
                        scroll: 0,
                        searchName: null,
                    });
                })
                .catch(error => Logger.error(error));
        };

        $scope.addWorkflow = function (candidateId, candidate, deffered) {
            WorkflowService.postWorkflow({
                recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                candidateId,
                talentId: candidate.talentID,
                positionId: recruiterCandidatesJobCtrl.positionData._id,
                employerId: recruiterCandidatesJobCtrl.positionData.employerId,
                employerRepId: recruiterCandidatesJobCtrl.positionData.employerId,
                title: recruiterCandidatesJobCtrl.positionData.jobTitle,
                dueDate: '2017-01-01',
            })
                .then((response) => {
                    candidate.workflow = response.result;
                    if (deffered) {
                        deffered.resolve(candidate.workflow);
                    } else {
                        const canPush = recruiterCandidatesJobCtrl.positionData &&
                            recruiterCandidatesJobCtrl.positionData.workflowData &&
                            recruiterCandidatesJobCtrl.positionData.workflowData.data &&
                            _.findIndex(recruiterCandidatesJobCtrl.positionData.workflowData.data,
                                { talentId: candidate.workflow.talentID }) < 0;
                        if (canPush) {
                            recruiterCandidatesJobCtrl.positionData.workflowData.data.push(candidate.workflow);
                        }
                    }
                }, () => {
                    if (deffered) {
                        deffered.resolve(null);
                    }
                })
                .catch(error => Logger.error(error));
            if (deffered) {
                return deffered.promise;
            }
        };

        recruiterCandidatesJobCtrl.claimCandidate = async function (candidate, openCandidates, canClaim) {
            if (!canClaim) {
                NotificationService.error('You have reached the maximum number of claimed candidates');
                return;
            }
            if (recruiterCandidatesJobCtrl.isClaiming) {
                return;
            }
            recruiterCandidatesJobCtrl.isClaiming = true;
            try {
                const [
                    { result: candidatesSearchResult },
                    { result: workflowSearchResult },
                ] = await Promise.all([
                    CandidateService.postCandidateSearch({ talentId: [candidate.talentID] }),
                    WorkflowService.getWorkflowSearch({
                        positionId: $stateParams.positionId,
                        recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                        talentId: candidate.talentID,
                    }),
                ]);

                if (candidatesSearchResult.length > 0) {
                    const candidateId = candidatesSearchResult[0]._id;
                    if (workflowSearchResult.length > 0) {
                        const workflow = _.find(workflowSearchResult, workflow => workflow.recruiterStatus.current === 'Prospect');
                        const { result: newWorkflow } = await WorkflowService.putRecruiterWorkflowStatus(workflow._id, {
                            status: 'Claimed',
                            reason: 'N/A',
                            details: {
                                recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                            },
                        });
                        candidate.workflow = newWorkflow;
                        const canPush = recruiterCandidatesJobCtrl.positionData &&
                            recruiterCandidatesJobCtrl.positionData.workflowData &&
                            recruiterCandidatesJobCtrl.positionData.workflowData.data &&
                            _.findIndex(recruiterCandidatesJobCtrl.positionData.workflowData.data, {
                                talentId: candidate.workflow.talentId,
                            }) < 0;
                        if (canPush) {
                            recruiterCandidatesJobCtrl.positionData.workflowData.data.push(candidate.workflow);
                        }
                    } else {
                        $scope.addWorkflow(candidateId, candidate);
                    }
                } else {
                    const { result: newCandidate } = await CandidateService.postCandidate({
                        talentId: candidate.talentID,
                    });

                    $scope.addWorkflow(newCandidate._id, candidate);
                }
                NotificationService.success('CANDIDATE_HAS_BEEN_CLAIMED');
            } catch (error) {
                Logger.error(error);
                NotificationService.error('CANDIDATE_CLAIM_ERROR');
            }
        };

        recruiterCandidatesJobCtrl.bulkClaimCandidates = async function ({ candidates }) {
            const talentIds = _.map(candidates, 'talentID');
            return RecruiterCandidateService.bulkClaimCandidates({
                talentIds,
                positionId: recruiterCandidatesJobCtrl.positionData._id,
                recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
            });
        };

        $scope.updateWorkFlowStatuses = async ({ candidate, status, reason, multi, promise, isBackFromRejected }) => {
            const workflow = _.find(recruiterCandidatesJobCtrl.positionData.workflowData.data, { talentId: candidate.talentID });

            try {
                if (workflow) {
                    const response = await WorkflowService.putRecruiterWorkflowStatus(workflow._id, {
                        status,
                        reason,
                        recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                        details: {
                            recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                        },
                    });

                    const currentCandidateStatus = _.get(candidate, 'workflow.recruiterStatus.current', null);
                    const currentEmployerStatus = _.get(candidate, 'workflow.employerStatus.current', null);
                    const isSentStatus = status === RECRUITER_WORKFLOW_STATUS.SENT;
                    const isCandidateSentStatus = currentCandidateStatus === RECRUITER_WORKFLOW_STATUS.SENT;
                    const isStatusAvailableToChangeEmployerStatus = [
                        RECRUITER_WORKFLOW_STATUS.PROSPECT,
                        RECRUITER_WORKFLOW_STATUS.READY,
                        RECRUITER_WORKFLOW_STATUS.REJECTED,
                    ].includes(status);

                    if (isSentStatus) {
                        const recruiterName = recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.fullName;

                        await WorkflowService.putEmployerWorkflowStatus(workflow._id, {
                            status: EMPLOYER_WORKFLOW_STATUS.REVIEWED,
                            reason: 'N/A',
                            confirmResponse: true,
                            userType: 'talentExpert',
                        });

                        WorkflowService.postWorkflowEvent(workflow._id, {
                            eventType: WorkflowService.eventTypes.TALENT_RESUME_FOR_EMPLOYER,
                            content: {
                                message: `talent Expert ${recruiterName} send Resume To Employer`,
                            },
                            entityId: workflow.candidateId,
                            recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                        });

                        if (promise) {
                            promise.resolve({});
                        }
                    } else if (isCandidateSentStatus && isStatusAvailableToChangeEmployerStatus) {
                        WorkflowService.putEmployerWorkflowStatus(workflow._id, {
                            status: 'None',
                            reason: 'N/A',
                            userType: 'talentExpert',
                        });
                    } else if (status === RECRUITER_WORKFLOW_STATUS.REJECTED) {
                        const isGoodRated = _.get(candidate, 'workflow.feedback.grades[0].grade', 0) === 1;

                        if (isGoodRated) {
                            await WorkflowService.putEmployerWorkflowStatus(workflow._id, {
                                status: EMPLOYER_WORKFLOW_STATUS.REJECTED,
                                reason: 'N/A',
                                confirmResponse: true,
                            });
                        } else {
                            const { positionId, talentId } = workflow;
                            await PositionService.deletePositionFeedback(positionId, { talentId });
                            await RecruiterFeedbackService.removeRequestFeedback(positionId, candidate);
                        }
                    } else if (isBackFromRejected && currentEmployerStatus === EMPLOYER_WORKFLOW_STATUS.REJECTED) {
                        const { status: prevEmployerStatus, reason: prevEmployerReason } = _.get(candidate, 'workflow.employerStatus.history[0]', {});
                        await WorkflowService.putEmployerWorkflowStatus(workflow._id, {
                            status: prevEmployerStatus,
                            reason: prevEmployerReason,
                            userType: 'talentExpert',
                        });
                    } else if (promise && multi) {
                        promise.resolve({});
                    }

                    const updatedWorkflow = _.get(response, 'result', null);
                    if (workflow) {
                        candidate.workflow = updatedWorkflow;
                    }

                    if (!multi) {
                        $state.go($state.current.name, {
                            workflowStep: status,
                            talentID: candidate.talentID,
                            currCandidatePage: 1,
                        }, { reload: true });
                    }
                }
            } catch (error) {
                Logger.error(error);
            }
        };

        $scope.updateWorkFlowStatusesV2 = async ({
            candidate,
            status,
            reason,
        }) => {
            const workflow = _.find(recruiterCandidatesJobCtrl.positionData.workflowData.data, { talentId: candidate.talentID });
            try {
                if (workflow) {
                    const response = await WorkflowService.putRecruiterWorkflowStatus(workflow._id, {
                        status,
                        reason,
                        recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                    });

                    const currentCandidateStatus = _.get(candidate, 'workflow.recruiterStatus.current', null);
                    const isSentStatus = status === RECRUITER_WORKFLOW_STATUS.SENT;
                    const isCandidateSentStatus = currentCandidateStatus === RECRUITER_WORKFLOW_STATUS.SENT;
                    const isStatusAvailableToChangeEmployerStatus = [
                        RECRUITER_WORKFLOW_STATUS.PROSPECT,
                        RECRUITER_WORKFLOW_STATUS.READY,
                        RECRUITER_WORKFLOW_STATUS.REJECTED,
                    ].includes(status);

                    if (isSentStatus) {
                        const recruiterName = recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.fullName;

                        await WorkflowService.putEmployerWorkflowStatus(workflow._id, {
                            status: EMPLOYER_WORKFLOW_STATUS.REVIEWED,
                            reason: 'N/A',
                            confirmResponse: true,
                            userType: 'talentExpert',
                        });

                        WorkflowService.postWorkflowEvent(workflow._id, {
                            eventType: WorkflowService.eventTypes.TALENT_RESUME_FOR_EMPLOYER,
                            content: {
                                message: `talent Expert ${recruiterName} send Resume To Employer`,
                            },
                            entityId: workflow.candidateId,
                        });
                    } else if (isCandidateSentStatus && isStatusAvailableToChangeEmployerStatus) {
                        WorkflowService.putEmployerWorkflowStatus(workflow._id, {
                            status: 'None',
                            reason: 'N/A',
                            userType: 'talentExpert',
                        });
                    } else if (status === RECRUITER_WORKFLOW_STATUS.REJECTED) {
                        const isGoodRated = _.get(candidate, 'workflow.feedback.grades[0].grade', 0) === 1;

                        if (isGoodRated) {
                            await WorkflowService.putEmployerWorkflowStatus(workflow._id, {
                                status: EMPLOYER_WORKFLOW_STATUS.REJECTED,
                                reason: 'N/A',
                            });
                        } else {
                            const { positionId, talentId } = workflow;
                            await PositionService.deletePositionFeedback(positionId, { talentId });
                            await RecruiterFeedbackService.removeRequestFeedback(positionId, candidate);
                        }
                    }
                    candidate.workflow = response.result;
                }
            } catch (error) {
                Logger.error(error);
            }
        };

        const tranlsateRejectedReasonCode = function (reason) {
            let newReason = '';
            switch (reason) {
                case 'TE - Uninterested in candidate':
                    newReason = 'Recruiter - Uninterested in candidate';
                    break;
                case 'TE - Not qualified for the job':
                    newReason = 'Recruiter - Not qualified for the job';
                    break;
                case 'TE - Remove candidate from database':
                    newReason = 'Recruiter - Remove candidate from database';
                    break;
                default:
                    newReason = reason;
                    break;
            }
            return newReason;
        };

        recruiterCandidatesJobCtrl.rejectCandidate = function (candidate, openCandidates, rejectCandidate) {
            const user = recruiterCandidatesJobCtrl.AuthService.getTrackUserData();
            const rejectReason = `${rejectCandidate.reason} [ by Talenya, ${user.name} ]`;

            $scope.updateWorkFlowStatuses({
                candidate,
                status: RECRUITER_WORKFLOW_STATUS.REJECTED,
                reason: tranlsateRejectedReasonCode(rejectReason),
            });
        };

        recruiterCandidatesJobCtrl.engageCandidate = function (candidate, openCandidates) {
            $scope.updateWorkFlowStatuses({
                candidate,
                status: RECRUITER_WORKFLOW_STATUS.ENGAGED,
            });
        };

        recruiterCandidatesJobCtrl.readyCandidate = function (candidate, openCandidates) {
            $scope.updateWorkFlowStatuses({
                candidate,
                status: RECRUITER_WORKFLOW_STATUS.READY,
            });
        };

        recruiterCandidatesJobCtrl.sentCandidate = function (candidate, openCandidates) {
            $scope.updateWorkFlowStatuses({
                candidate,
                status: RECRUITER_WORKFLOW_STATUS.SENT,
            });
        };

        recruiterCandidatesJobCtrl.concatViaPhone = async (candidate, openCandidates, contactCandidate) => {
            if (contactCandidate.contactCandidateDiscuss) {
                CandidateService.postCandidateComment(candidate.workflow.candidateId, {
                    content: `Contact candidate regarding ${recruiterCandidatesJobCtrl.positionData.jobTitle
                    } for ${recruiterCandidatesJobCtrl.positionData.employerData.name} \n${contactCandidate.contactCandidateDiscuss}`,
                    positionId: candidate.workflow.positionId,
                    recruiterId: candidate.workflow.recruiterId,
                });
            }

            await RouteService.getPositionApprovalLinks($stateParams.positionId, {
                candidates: [{
                    talentId: candidate.workflow.talentId,
                    workflowId: candidate.workflow._id,
                    channelType: recruiterCandidatesJobCtrl.CONTACT_CHANNEL_TYPES.TALK,
                }],
                sentBy: 'recruiter',
            });

            await WorkflowService.postWorkflowEvent(candidate.workflow._id, {
                eventType: WorkflowService.eventTypes.TALENT_EXPERT_CONTACT_CANDIDATE,
                content: {
                    type: recruiterCandidatesJobCtrl.CONTACT_CHANNEL_TYPES.TALK,
                    message: `talent Expert ${recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.fullName} contacted Candidate`,
                    recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                },
            });

            contactCandidate.response = contactCandidate.contactCandidateDiscuss;
            contactCandidate.responseChannelType = 'PHONE';

            try {
                const mobileNumber = _.get(candidate, 'candidateData.contact.mobile.0');
                const telephoneNumber = _.get(candidate, 'candidateData.contact.telephone.0');

                const phoneMessageTextContent = {
                    subject: 'Contact Candidate',
                    body: contactCandidate.response,
                    destinations: [{
                        phone: mobileNumber || telephoneNumber,
                    }],
                    source: {
                        recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                    },
                    messageContext: {
                        positionId: $stateParams.positionId,
                        workflowId: candidate.workflow._id,
                    },
                };

                MessageService.addMessage(phoneMessageTextContent);
            } catch (error) {
                Logger.error(error);
            }
        };

        recruiterCandidatesJobCtrl.contactCandidate = async function (candidate, openCandidates, contactCandidate, flowType = 'contactCandidate') {
            await recruiterCandidatesJobCtrl.concatViaPhone(candidate, openCandidates, contactCandidate);

            return recruiterCandidatesJobCtrl.sendMsg({
                candidate,
                openCandidates,
                contactCandidate,
                type: 'response',
                email: null,
                needToBeReloaded: false,
                flowType,
            });
        };

        recruiterCandidatesJobCtrl.sendMsgAddContactEvent = function ({ candidate, msg, type, responseVia = [], deffered }) {
            let event = null;

            if (type === 'response') {
                event = {
                    eventType: WorkflowService.eventTypes.CONFIRM_RESPONSE,
                    content: {
                        type,
                        message: 'Candidate confirm response',
                        responseVia,
                    },
                };
            } else {
                event = {
                    eventType: WorkflowService.eventTypes.TALENT_EXPERT_CONTACT_CANDIDATE,
                    content: {
                        type,
                        message: `talent Expert ${recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.fullName} contacted Candidate${msg}`,
                        responseVia,
                    },
                };
            }

            return WorkflowService.postWorkflowEvent(candidate.workflow._id, event)
                .then(() => {
                    deffered.resolve();
                    (candidate.workflow.events || []).unshift(event);
                })
                .catch(error => Logger.error(error));
        };

        // todo refactor me pls
        recruiterCandidatesJobCtrl.sendMsg = async function (params) {
            const {
                candidate,
                openCandidates,
                contactCandidate,
                type,
                email,
                needToBeReloaded = true,
                flowType,
                selectedMessage,
            } = params;

            const contactCandidateFlow = flowType === 'contactCandidate';

            try {
                let msg = '';
                let subject = '';
                const responseVia = [];

                const hasTemplate = [
                    CONTACT_CHANNEL_TYPES.LINKEDIN_MESSAGE,
                    CONTACT_CHANNEL_TYPES.EMAIL,
                    CONTACT_CHANNEL_TYPES.LINKEDIN_INMAIL,
                    CONTACT_CHANNEL_TYPES.FACEBOOK,
                ].includes(type);

                const useChromeExtension = [CONTACT_CHANNEL_TYPES.LINKEDIN_MESSAGE].includes(type);

                if (type === 'response' && contactCandidate.isResponseByPhone) {
                    await recruiterCandidatesJobCtrl.concatViaPhone(candidate, openCandidates, contactCandidate);
                }

                if (hasTemplate) {
                    if (!contactCandidate.msgContent) {
                        msg = '';
                    } else {
                        msg = contactCandidate.msgContent;
                    }
                    if (!contactCandidate.msgSubject) {
                        subject = '';
                    } else {
                        subject = contactCandidate.msgSubject.replaceAll('</p>', '\r\n');
                        subject = subject.replaceAll('<span field=\'prospectFirstName\'>', '');
                        subject = subject.replaceAll('<span field=\'jobTitle\'>', '');
                        subject = subject.replaceAll('<span field=\'teName\'>', '');
                        subject = subject.replaceAll('<span field=\'teFirstName\'>', '');
                        subject = subject.replaceAll('<span field=\'teEmail\'>', '');
                        subject = subject.replaceAll('<span field=\'tePhone\'>', '');
                        subject = subject.replaceAll('<span field=\'employerName\'>', '');
                        subject = subject.replaceAll('</span>', '');
                        subject = subject.replaceAll('<br />', '\r\n');
                        subject = subject.replaceAll('<br>', '\r\n');
                        subject = subject.replaceAll('&nbsp;', ' ');
                        subject = `<div>${subject}</div>`;
                        subject = $(subject)
                            .text();
                    }
                } else if (type === 'response') {
                    if (!contactCandidate.response) {
                        msg = '';
                    } else {
                        msg = contactCandidate.response;
                    }
                    const noteData = {};
                    noteData.text = $filter('translate')('THE_CANDIDATE_RESPONDED_VIA');
                    noteData.type = 'comment';

                    const responseChannelType = contactCandidate.responseChannelType;

                    if (responseChannelType && CONTACT_CANDIDATE_RESPONSE_OPTIONS[responseChannelType]) {
                        noteData.text += `${$filter('translate')(responseChannelType)} `;
                        responseVia.push(CONTACT_CANDIDATE_RESPONSE_OPTIONS[responseChannelType]);
                    }

                    const isInterestedTranslation = contactCandidate.contactCandidateOutcome === 'forward'
                        ? 'TALENT_INTERESTED_CONFIRM_RESPONSE_NOTE'
                        : 'TALENT_NOT_INTERESTED_CONFIRM_RESPONSE_NOTE';

                    const isInterestedText = $filter('translate')(isInterestedTranslation);
                    noteData.text += ` \n${isInterestedText}`;
                    noteData.text += ` \n${msg}`;
                    recruiterCandidatesJobCtrl.addNote(candidate, noteData);
                }

                const defferedContactEvent = $q.defer();
                const isEmail = CONTACT_CHANNEL_TYPES.EMAIL === type && contactCandidate.checkEmail && email && email.length > 0;
                const isChromeExtensionAvailable = useChromeExtension && contactCandidate.checkLinkedin == true && window.TE && window.TE.sendMessage;
                const isLinkedin = CONTACT_CHANNEL_TYPES.LINKEDIN_MESSAGE === type && isChromeExtensionAvailable;

                if (isEmail && contactCandidateFlow) {
                    const sendEmailResponse = await CandidatesContactService.contactCandidatesWithHiddenDetailsByEmail({
                        contactType: 'auto',
                        positionId: $stateParams.positionId,
                        recipientsData: [{
                            talentId: candidate.talentID,
                            workflowId: candidate.workflow._id,
                            candidateId: candidate.workflow.candidateId,
                            emails: email,
                        }],
                        message: selectedMessage || contactCandidate?.msg?.template,
                        emailData: {
                            subject,
                            body: contactCandidate.msgContent,
                            sentBy: 'recruiter',
                            from: 'talentExperts',
                        },
                    });

                    const hasErrors = !!_.chain(sendEmailResponse)
                        .get('result.data')
                        .find({ status: 'error' })
                        .value();

                    if (hasErrors) {
                        NotificationService.error($filter('translate')('POSITION_APPROVAL_EMAILS_NOT_SENT'));
                    }

                    if (needToBeReloaded) {
                        $state.go($state.current, $stateParams, { reload: true });
                    }
                } else if (isEmail && !contactCandidateFlow) {
                    if (contactCandidate.checkEmail && email && email.length > 0) {
                        const messageEmailContent = {
                            subject,
                            body: contactCandidate.msgContent,
                            destinations: [],
                            source: {
                                recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                            },
                            messageContext: {
                                positionId: $stateParams.positionId,
                                workflowId: candidate.workflow._id,
                            },
                        };
                        const recruiterEmail = Recruiter.getEmail(recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData);
                        let recruiterPhone = '';

                        if (recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.contact.phone.length > 0) {
                            recruiterPhone = recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.contact.phone[0].value;
                        }

                        for (let i = 0; i < email.length; i++) {
                            messageEmailContent.destinations.push({
                                email: email[i],
                            });
                        }

                        await Promise.all([
                            RouteService.sendContactCandidateMail({
                                from: 'talentExperts',
                                body: contactCandidate.msgContent,
                                to: email,
                                subject,
                                talentExpertName: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.fullName,
                                talentExpertEmail: recruiterEmail,
                                talentExpertCellPhone: recruiterPhone,
                            }),
                            MessageService.addMessage(messageEmailContent),
                            recruiterCandidatesJobCtrl.sendMsgAddContactEvent({
                                candidate,
                                msg,
                                type,
                                deffered: defferedContactEvent,
                            }),
                        ]);
                    }
                } else if (isLinkedin) {
                    const messageLinkedinContent = {
                        subject: 'Contact Candidate',
                        body: contactCandidate.msgContent,
                        destinations: [],
                        source: {
                            recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                        },
                        messageContext: {
                            positionId: $stateParams.positionId,
                            workflowId: candidate.workflow._id,
                        },
                    };
                    const linkedinUrl = _.find(candidate.candidateData.contact.webAddress, { type: 'linkedin' });
                    if (linkedinUrl) {
                        window.TE.onMessageSent = function (data) {
                            if (data.statusCode == 1) {
                                CandidatesContactService.addCandidateContactCampaignSentMessage({
                                    contactType: 'auto',
                                    sentMessage: {
                                        ...contactCandidate?.msg?.template,
                                        messageUuid: candidate?.msg.messageUuid,
                                    },
                                    positionId: $stateParams.positionId,
                                    talentId: candidate.talentID,

                                });

                                MessageService.addMessage(messageLinkedinContent);

                                NotificationService.success('CHROME_EXTENSION_SUCCESS_NOTIFCATION');

                                if (!contactCandidate.checkEmail && contactCandidate.checkLinkedin == true) {
                                    recruiterCandidatesJobCtrl.sendMsgAddContactEvent({
                                        candidate,
                                        msg,
                                        type,
                                        deffered: defferedContactEvent,
                                    });
                                }
                            } else if (data.statusCode == 4) {
                                Logger.error('Error chrome extension =>', data);

                                NotificationService.error('CHROME_EXTENSION_FAILED_NOTIFCATION');
                            } else if (data.statusCode == 5) {
                                MessageService.addMessage(messageLinkedinContent);
                                NotificationService.success('CHROME_EXTENSION_SEND_INVATION_AND_MESSAGE');
                                if (!contactCandidate.checkEmail && contactCandidate.checkLinkedin == true) {
                                    recruiterCandidatesJobCtrl.sendMsgAddContactEvent({
                                        candidate,
                                        msg,
                                        type,
                                        deffered: defferedContactEvent,
                                    });
                                }
                            } else if (data.statusCode == 6) {
                                NotificationService.error('CHROME_EXTENSION_CANNOT_SEND_INVATION_IS_TOO_LONG');
                            } else if (data.statusCode == 7) {
                                NotificationService.error('CHROME_EXTENSION_INVATION_ALREADY_SENT');
                            } else {
                                Logger.error('Error chrome extension =>', data);

                                NotificationService.error('CHROME_EXTENSION_FAILED_NOTIFCATION');
                            }
                        };

                        const linkedinMsg = EmailService.cleanUpSpecificHTMLTags(contactCandidate.msgContent);
                        window.TE.sendMessage(linkedinMsg, linkedinUrl.url);
                        messageLinkedinContent.destinations.push({
                            linkedin: linkedinUrl.url,
                        });

                        messageLinkedinContent.destinations.push({
                            candidateId: _.get(candidate, 'workflow.candidateId'),
                        });
                    }
                } else if ([CONTACT_CHANNEL_TYPES.LINKEDIN_INMAIL, CONTACT_CHANNEL_TYPES.FACEBOOK].includes(type)) {
                    const webAddressTypes = {
                        [CONTACT_CHANNEL_TYPES.LINKEDIN_INMAIL]: 'linkedin',
                        [CONTACT_CHANNEL_TYPES.FACEBOOK]: 'facebook',
                    };

                    const webAddress = _.find(candidate.candidateData.contact.webAddress, { type: webAddressTypes[type] });

                    const messageContent = {
                        subject,
                        body: contactCandidate.msgContent,
                        destinations: [{
                            [type]: _.get(webAddress, 'url'),
                        }],
                        source: {
                            recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                        },
                        messageContext: {
                            positionId: $stateParams.positionId,
                            workflowId: candidate.workflow._id,
                        },
                    };

                    if (type === CONTACT_CHANNEL_TYPES.LINKEDIN_INMAIL) {
                        let sentMessage;

                        if (!_.isEmpty(selectedMessage)) {
                            sentMessage = {
                                ...selectedMessage,
                                channel: type,
                            };
                        } else {
                            sentMessage = {
                                ...contactCandidate?.msg.template,
                                channel: type,
                                messageUuid: candidate?.msg?.messageUuid,
                            };
                        }

                        await CandidatesContactService.addCandidateContactCampaignSentMessage({
                            contactType: 'manual',
                            sentMessage,
                            positionId: $stateParams.positionId,
                            talentId: candidate.talentID,

                        });
                    }

                    await Promise.allSettled([
                        MessageService.addMessage(messageContent),
                        recruiterCandidatesJobCtrl.sendMsgAddContactEvent({
                            candidate,
                            msg,
                            type,
                            responseVia,
                            deffered: defferedContactEvent,
                        }),
                    ]);
                } else {
                    if (type === 'response') {
                        const params = {
                            workflowId: candidate.workflow._id,
                            channelType: recruiterCandidatesJobCtrl.CONTACT_CANDIDATE_RESPONSE_OPTIONS[contactCandidate.responseChannelType],
                            responseType: contactCandidate.contactCandidateOutcome,
                        };

                        let step = recruiterCandidatesJobCtrl.workflow;

                        if (recruiterCandidatesJobCtrl.workflow === RECRUITER_WORKFLOW_STATUS.CLAIMED
                            && contactCandidate.contactCandidateOutcome === 'forward') {
                            step = RECRUITER_WORKFLOW_STATUS.SENT;
                        } else if (contactCandidate.contactCandidateOutcome === 'reject') {
                            step = RECRUITER_WORKFLOW_STATUS.REJECTED;
                        }

                        await RouteService.confirmResponse($stateParams.positionId, params);
                        $state.go($state.current.name, {
                            currCandidatePage: 1,
                            workflowStep: step,
                            talentID: candidate.talentID,
                        }, { reload: true });
                        return;
                    }

                    await recruiterCandidatesJobCtrl.sendMsgAddContactEvent({
                        candidate,
                        msg,
                        type,
                        responseVia,
                        deffered: defferedContactEvent,
                    });
                }

                if (contactCandidate.contactCandidateOutcome === 'reject' && type === 'response') {
                    // reject
                    const rejectReason = _.get(contactCandidate, 'rejectCandidate.reason', 'N/A');

                    $scope.updateWorkFlowStatuses({
                        candidate,
                        status: RECRUITER_WORKFLOW_STATUS.REJECTED,
                        reason: tranlsateRejectedReasonCode(rejectReason),
                    });
                } else if (contactCandidate.contactCandidateOutcome === 'forward' && type === 'response') {
                    // forward
                    $scope.updateWorkFlowStatuses({
                        candidate,
                        status: RECRUITER_WORKFLOW_STATUS.ENGAGED,
                        reason: 'N/A',
                    });
                } else if (needToBeReloaded) {
                    defferedContactEvent.promise.then(() => {
                        $state.go($state.current.name, {
                            workflowStep: recruiterCandidatesJobCtrl.workflow,
                            talentID: candidate.talentID,
                        }, { reload: $state.current.name });
                    })
                        .catch(error => Logger.error(error));
                }
            } catch (error) {
                Logger.error(error.message);
            }
        };

        recruiterCandidatesJobCtrl.interviewCandidate = function (candidate, openCandidates, interview) {
            if (interview.outcome == null) {
                interview.outcomeError = true;
                return;
            }
            interview.candidateId = candidate.workflow.candidateId;
            interview.positionId = $stateParams.positionId;
            interview.recruiterId = recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id;
            if (interview.statusCurrentJob) {
                interview.statusCurrentJob = interview.statusCurrentJob.value;
            }
            interview.type = 'interview_talent';
            CandidateService.postCandidateInterview(interview.candidateId, interview)
                .then((response) => {
                    WorkflowService.postWorkflowEvent(candidate.workflow._id, {
                        eventType: WorkflowService.eventTypes.INTERVIEW_CREATED,
                        content: {
                            message: `talent Expert ${recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.fullName} created interview`,
                        },
                        entityId: response.result._id,
                        recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                    });
                })
                .catch(error => Logger.error(error));
            if (interview.outcome == 'reject') {
                $scope.updateWorkFlowStatuses({
                    candidate,
                    status: RECRUITER_WORKFLOW_STATUS.REJECTED,
                    reason: tranlsateRejectedReasonCode(interview.reason),
                });
            } else if (interview.outcome == 'forward' && candidate.workflow.recruiterStatus.current == 'Claimed') {
                $scope.updateWorkFlowStatuses({
                    candidate,
                    status: RECRUITER_WORKFLOW_STATUS.ENGAGED,
                    reason: 'N/A',
                });
            } else {
                $state.go($state.current.name, {
                    workflowStep: recruiterCandidatesJobCtrl.workflow,
                    talentID: candidate.talentID,
                }, { reload: $state.current.name });
            }
        };

        recruiterCandidatesJobCtrl.getNotesAndComments = function (candidate) {
            const deferred = $q.defer();
            if (!candidate.workflow) {
                CandidateService.postCandidateSearch({ talentId: [candidate.talentID] })
                    .then((response) => {
                        if (response.result.length > 0) {
                            deferred.resolve(_.get(response, 'result[0]._id'));
                        } else {
                            deferred.resolve(null);
                        }
                    })
                    .catch(error => Logger.error(error));
            } else {
                deferred.resolve(candidate.workflow.candidateId);
            }
            deferred.promise.then((candidateId) => {
                if (candidateId) {
                    CandidateService.getCandidateNotes(candidateId)
                        .then((response) => {
                            candidate.notes = _.filter(response.result, note =>
                                note.recruiterId === recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id);
                        })
                        .catch(error => Logger.error(error));

                    CandidateService.getCandidateComments(candidateId)
                        .then((response) => {
                            candidate.comments = response.result;
                            if (candidate.comments.length > 0) {
                                RecruiterService.postRecruiterSearch({ recruiterIDs: _.map(candidate.comments, 'recruiterId') })
                                    .then((response) => {
                                        for (let j = 0; j < candidate.comments.length; j++) {
                                            for (let i = 0; i < response.result.length; i++) {
                                                if (candidate.comments[j].recruiterId === _.get(response, `result[${i}]._id`)) {
                                                    candidate.comments[j].recruiterData = _.get(response, `result[${i}].fullName`);
                                                    break;
                                                }
                                            }
                                        }
                                    })
                                    .catch(error => Logger.error(error));
                            }
                        })
                        .catch(error => Logger.error(error));
                } else {
                    candidate.notes = [];
                    candidate.comments = [];
                }
            })
                .catch(error => Logger.error(error));
        };

        recruiterCandidatesJobCtrl.addNote = function (candidate, noteData) {
            if (!noteData.text || noteData.text == '') {
                return;
            }

            const deferred = $q.defer();
            if (!candidate.workflow) {
                CandidateService.postCandidateSearch({ talentId: [candidate.talentID] })
                    .then((response) => {
                        if (response.result.length > 0) {
                            deferred.resolve(_.get(response, 'result[0]._id'));
                        } else {
                            CandidateService.postCandidate({
                                talentId: candidate.talentID,
                            })
                                .then((response) => {
                                    deferred.resolve(response.result._id);
                                })
                                .catch(error => Logger.error(error));
                        }
                    })
                    .catch(error => Logger.error(error));
            } else {
                deferred.resolve(candidate.workflow.candidateId);
            }
            deferred.promise.then((candidateId) => {
                if (noteData.type === 'note') {
                    CandidateService.postCandidateNote(candidateId, {
                        positionId: recruiterCandidatesJobCtrl.positionData._id,
                        recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                        employerId: recruiterCandidatesJobCtrl.positionData.employerId,
                        content: noteData.text,
                    })
                        .then((response) => {
                            candidate.notes = candidate.notes || [];
                            candidate.notes.push(response.result);
                        })
                        .catch(error => Logger.error(error));
                } else if (noteData.type === 'comment') {
                    CandidateService.postCandidateComment(candidateId, {
                        positionId: recruiterCandidatesJobCtrl.positionData._id,
                        recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                        employerId: recruiterCandidatesJobCtrl.positionData.employerId,
                        content: noteData.text,
                    })
                        .then((response) => {
                            response.result.author = recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.fullName;

                            candidate.comments.push(response.result);
                        })
                        .catch(error => Logger.error(error));
                }
            })
                .catch(error => Logger.error(error));
        };

        recruiterCandidatesJobCtrl.approveSubmission = function (candidate, openCandidates, approveSubmission) {
            approveSubmission.finalInteview = {};
            if (approveSubmission.interview) {
                if (approveSubmission.interview.checkTitle) {
                    approveSubmission.finalInteview.title = approveSubmission.interview.title;
                }
                if (approveSubmission.interview.checkCompensationExpectations) {
                    approveSubmission.finalInteview.compensationExpectations = approveSubmission.interview.compensationExpectations;
                }
                if (approveSubmission.interview.checkLocationPreferences) {
                    approveSubmission.finalInteview.locationPreferences = approveSubmission.interview.locationPreferences;
                }
                if (approveSubmission.interview.checkStatusCurrentJob && approveSubmission.interview.statusCurrentJob) {
                    approveSubmission.finalInteview.statusCurrentJob = approveSubmission.interview.statusCurrentJob.value;
                }
                if (approveSubmission.interview.checkReasonForLeaving) {
                    approveSubmission.finalInteview.reasonForLeaving = approveSubmission.interview.reasonForLeaving;
                }
                if (approveSubmission.interview.checkLimitations) {
                    approveSubmission.finalInteview.limitations = approveSubmission.interview.limitations;
                }
                if (approveSubmission.interview.checkOverallImpression) {
                    approveSubmission.finalInteview.overallImpression = approveSubmission.interview.overallImpression;
                }
                approveSubmission.finalInteview.positionId = $stateParams.positionId;
                approveSubmission.finalInteview.recruiterId = $stateParams.recruiterId;
                approveSubmission.finalInteview.employerRepId = recruiterCandidatesJobCtrl.positionData.employerId;
                const workflow = _.find(recruiterCandidatesJobCtrl.positionData.workflowData.data, { talentId: candidate.talentID });
                if (workflow) {
                    CandidateService.postCandidateInterview(workflow.candidateId, approveSubmission.finalInteview);
                }
            }
            $scope.updateWorkFlowStatuses({
                candidate,
                status: RECRUITER_WORKFLOW_STATUS.READY,
                reason: 'N/A',
            });
        };

        recruiterCandidatesJobCtrl.multiSendResumeToEmployer = function (candidates, openCandidates, sendResumeToEmployer) {
            const deffered = $q.defer();
            recruiterCandidatesJobCtrl.multiData = sendResumeToEmployer;
            for (let i = 0; i < candidates.length; i++) {
                const candidate = recruiterCandidatesJobCtrl.positionData.workflowData.candidates.resultList[i];
                if (i === candidates.length - 1) {
                    $scope.updateWorkFlowStatuses({
                        candidate,
                        status: RECRUITER_WORKFLOW_STATUS.SENT,
                        reason: 'N/A',
                        multi: true,
                        promise: deffered,
                    });
                } else {
                    $scope.updateWorkFlowStatuses({
                        candidate,
                        status: RECRUITER_WORKFLOW_STATUS.SENT,
                        reason: 'N/A',
                        multi: true,
                    });
                }
            }
            deffered.promise.then(() => {
                let sendResumeToEmployer = recruiterCandidatesJobCtrl.multiData;
                const sendEmail = (sendResumeToEmployer.value == 'yes');
                if (!sendResumeToEmployer.email || sendResumeToEmployer.email.length <= 0) {
                    return;
                }
                const emailToSend = sendResumeToEmployer.email;
                if (sendEmail) {
                    if (sendEmail && emailToSend) {
                        const prospectLink = `${EnvSettings.Auth0RedirectUrl}#/employer/${recruiterCandidatesJobCtrl.positionData.employerId
                        }/candidatesJob/${
                            recruiterCandidatesJobCtrl.positionData._id}/` +
                            'workflowStep/Prospect/candidatesPage/1/scroll/0/candidate/';
                        const recruiterEmail = Recruiter.getEmail(recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData);
                        let recruiterPhone = '';
                        if (recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.contact.phone.length > 0) {
                            recruiterPhone = recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.contact.phone[0].value;
                        }
                        sendResumeToEmployer = {
                            employerEmails: emailToSend,
                            employerFirstName: recruiterCandidatesJobCtrl.positionData.employerData.name,
                            jobTitle: recruiterCandidatesJobCtrl.positionData.jobTitle,
                            companyName: recruiterCandidatesJobCtrl.positionData.employerData.name,
                            link: prospectLink,
                            talentExpertName: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.fullName,
                            talentExpertEmail: recruiterEmail,
                            talentExpertCellPhone: recruiterPhone,
                            talentExpertMessage: sendResumeToEmployer.talentExpertMessage,
                            multi: true,
                        };
                        RecruiterService.sendResmueToEmployer(sendResumeToEmployer)
                            .catch(error => Logger.error(error));
                    }
                    $state.go($state.current.name, {
                        workflowStep: RECRUITER_WORKFLOW_STATUS.SENT,
                    }, { reload: true });
                }
            })
                .catch(error => Logger.error(error));
        };

        recruiterCandidatesJobCtrl.backToPreviousStatusRejected = function (candidate, openCandidates) {
            if (candidate.workflow.recruiterStatus.history && candidate.workflow.recruiterStatus.history.length > 0) {
                $scope.updateWorkFlowStatuses({
                    candidate,
                    status: candidate.workflow.recruiterStatus.history[0].status,
                    reason: candidate.workflow.recruiterStatus.history[0].reason,
                    isBackFromRejected: true,
                });
            }
        };

        recruiterCandidatesJobCtrl.backToPreviousStatus = function (candidate, openCandidates) {
            const statues = ['Prospect', 'Claimed', 'Engaged', 'Ready', 'Sent', 'Hired', 'Rejected'];
            $scope.updateWorkFlowStatuses({
                candidate,
                status: statues[statues.indexOf(candidate.workflow.recruiterStatus.current) - 1],
                reason: 'N/A',
            });
        };

        // eslint-disable-next-line max-len
        recruiterCandidatesJobCtrl.updateRecruiterStatusAccordingToEmployer = function (candidate, workflow_id, talent_id, status, reason, positionStatus) {
            WorkflowService.putRecruiterWorkflowStatus(workflow_id, {
                status,
                reason,
                details: {
                    recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                },
            })
                .then(() => {
                    let hiredPositions = 0;
                    for (let i = 0; i < recruiterCandidatesJobCtrl.positionData.workflowData.data.length; i++) {
                        if (recruiterCandidatesJobCtrl.positionData.workflowData.data[i].employerStatus.current === 'Hired') {
                            hiredPositions++;
                        }
                    }
                    hiredPositions += (status === 'Hired' ? 1 : candidate.workflow.recruiterStatus.current === 'Hired' ? -1 : 0);
                    if (recruiterCandidatesJobCtrl.positionData.numOfPositions - hiredPositions !==
                        recruiterCandidatesJobCtrl.positionData.remainingPositions) {
                        recruiterCandidatesJobCtrl.positionData.remainingPositions =
                            recruiterCandidatesJobCtrl.positionData.numOfPositions - hiredPositions;
                        PositionService.addPosition({
                            remainingPositions: recruiterCandidatesJobCtrl.positionData.remainingPositions,
                            _id: recruiterCandidatesJobCtrl.positionData._id,
                        }, true);
                    }
                    if (recruiterCandidatesJobCtrl.positionData.remainingPositions <= 0 && status === 'Hired' ||
                        recruiterCandidatesJobCtrl.positionData.remainingPositions >= 1 && status === 'Sent') {
                        if (recruiterCandidatesJobCtrl.positionData.status.current !== positionStatus) {
                            PositionService.changePositionStatus(recruiterCandidatesJobCtrl.positionData._id, {
                                status: positionStatus,
                            })
                                .then(() => {
                                    recruiterCandidatesJobCtrl.positionData.status.history.push({
                                        current: recruiterCandidatesJobCtrl.positionData.status.current,
                                        timestamp: recruiterCandidatesJobCtrl.positionData.status.timestamp,
                                    });
                                    recruiterCandidatesJobCtrl.positionData.status.current = positionStatus;
                                })
                                .catch(error => Logger.error(error));
                        }
                    }
                    $state.go($state.current.name, {
                        workflowStep: status,
                        talentID: talent_id,
                    }, { reload: $state.current.name });
                })
                .catch(error => Logger.error(error));
        };

        recruiterCandidatesJobCtrl.moveStatusEmployerTo = function (candidate, openCandidates, onBehalfOfEmployer) {
            const workflow = _.find(recruiterCandidatesJobCtrl.positionData.workflowData.data, { talentId: candidate.talentID });

            if (workflow && onBehalfOfEmployer.status !== workflow.employerStatus.current) {
                WorkflowService.putEmployerWorkflowStatus(workflow._id, {
                    status: onBehalfOfEmployer.status,
                    reason: onBehalfOfEmployer.onBehalfOfEmployerRejectReason || 'N/A',
                    userType: 'talentExpert',
                })
                    .then(() => {
                        if (onBehalfOfEmployer.status === 'Hired') {
                            recruiterCandidatesJobCtrl.updateRecruiterStatusAccordingToEmployer(candidate, workflow._id, candidate.talentID, onBehalfOfEmployer.status, 'N/A', 'Finished');
                        } else if (onBehalfOfEmployer.status === 'Rejected') {
                            recruiterCandidatesJobCtrl.updateRecruiterStatusAccordingToEmployer(candidate, workflow._id, candidate.talentID, 'Rejected', 'Employer - Rejected by employer', 'Active');
                        } else if ((candidate.workflow.recruiterStatus.current === 'Hired' && onBehalfOfEmployer.status !== 'Hired')
                            || candidate.workflow.recruiterStatus.current === 'Rejected' && onBehalfOfEmployer.status !== 'Hired') {
                            recruiterCandidatesJobCtrl.updateRecruiterStatusAccordingToEmployer(candidate, workflow._id, candidate.talentID, 'Sent', 'N/A', 'Active');
                        } else {
                            $state.go($state.current.name, {
                                workflowStep: recruiterCandidatesJobCtrl.workflow,
                                talentID: candidate.talentID,
                            }, { reload: $state.current.name });
                        }
                    })
                    .catch(error => Logger.error(error));
            }
        };

        recruiterCandidatesJobCtrl.hideCandidate = function (candidate) {
            if (!candidate) {
                return;
            }
            CandidateService.postCandidateSearch({ talentId: [candidate.talentID] })
                .then((response) => {
                    if (response.result.length > 0) {
                        const candidateId = _.get(response, 'result[0]._id');
                        WorkflowService.getWorkflowSearch({
                            positionId: $stateParams.positionId,
                            recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                            talentId: candidate.talentID,
                        })
                            .then((response) => {
                                if (response.result.length > 0) {
                                    const workflow = _.find(response.result, workflow => workflow.recruiterStatus.current === 'Prospect');
                                    WorkflowService.putRecruiterWorkflowStatus(workflow._id, {
                                        status: 'Hidden',
                                        reason: 'N/A',
                                        details: {
                                            recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                                        },
                                    })
                                        .catch(error => Logger.error(error));
                                } else {
                                    const deffered = $q.defer();
                                    $scope.addWorkflow(candidateId, candidate, deffered)
                                        .then((workflow) => {
                                            if (workflow) {
                                                WorkflowService.putRecruiterWorkflowStatus(workflow._id, {
                                                    status: 'Hidden',
                                                    reason: 'N/A',
                                                    details: {
                                                        recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                                                    },
                                                })
                                                    .catch(error => Logger.error(error));
                                            }
                                        })
                                        .catch(error => Logger.error(error));
                                }
                            })
                            .catch(error => Logger.error(error));
                    } else {
                        CandidateService.postCandidate({
                            talentId: candidate.talentID,
                        })
                            .then((response) => {
                                const deffered = $q.defer();
                                $scope.addWorkflow(response.result._id, candidate, deffered)
                                    .then((workflow) => {
                                        if (workflow) {
                                            WorkflowService.putRecruiterWorkflowStatus(workflow._id, {
                                                status: 'Hidden',
                                                reason: 'N/A',
                                                details: {
                                                    recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                                                },
                                            })
                                                .then((response) => {
                                                    candidate.workflow = response.result;
                                                })
                                                .catch(error => Logger.error(error));
                                        }
                                    })
                                    .catch(error => Logger.error(error));
                            })
                            .catch(error => Logger.error(error));
                    }
                    NotificationService.success('CANDIDATE_HAS_BEEN_REMOVED');
                })
                .catch(error => Logger.error(error));
        };

        recruiterCandidatesJobCtrl.backToProspects = function (candidate, openCandidates) {
            $scope.updateWorkFlowStatuses({
                candidate,
                status: RECRUITER_WORKFLOW_STATUS.PROSPECT,
                reason: 'N/A',
            });
        };

        recruiterCandidatesJobCtrl.multiBackToProspect = async (candidates, openCandidates) => {
            const deffered = $q.defer();
            const resultList = _.get(recruiterCandidatesJobCtrl, 'positionData.workflowData.candidates.resultList', []);
            for (let i = 0; i < candidates.length; i++) {
                const candidate = _.find(resultList, { talentID: candidates[i].talentID });
                if (i == candidates.length - 1) {
                    $scope.updateWorkFlowStatuses({
                        candidate,
                        status: RECRUITER_WORKFLOW_STATUS.PROSPECT,
                        reason: 'N/A',
                        multi: true,
                        promise: deffered,
                    });
                } else {
                    $scope.updateWorkFlowStatuses({
                        candidate,
                        status: RECRUITER_WORKFLOW_STATUS.PROSPECT,
                        reason: 'N/A',
                        multi: true,
                    });
                }
            }

            if (candidates.length === resultList.length) {
                try {
                    const { recruiterId, positionId } = $stateParams;
                    const workflowStep = await RecruiterWorkflowStepResolver.getWorkflowStep(positionId, recruiterId);

                    return $state.go($state.current.name, {
                        currCandidatePage: 1,
                        scroll: 0,
                        talentID: null,
                        feedbackFilterMode: null,
                        workflowStep,
                    }, { reload: $state.current.name });
                } catch (error) {
                    Logger.error(error);
                    return;
                }
            }
            deffered.promise.then(() => {
                $state.go($state.current.name, {}, { reload: true });
            })
                .catch(error => Logger.error(error));
        };

        recruiterCandidatesJobCtrl.copyLinkToClipboard = function (candidate) {
            const prospectLink = `${EnvSettings.Auth0RedirectUrl}#/employer/${
                recruiterCandidatesJobCtrl.positionData.employerId}/candidatesJob/${recruiterCandidatesJobCtrl.positionData._id}/` +
                `workflowStep/Prospect/candidatesPage/1/scroll/0/candidate/${candidate.talentID}`;
            clipboard.copyText(prospectLink);
            NotificationService.success('Copied');
        };

        // eslint-disable-next-line max-len
        recruiterCandidatesJobCtrl.createResumeForEmployerIfNoExists = async function (candidate, openCandidates, talentForEmployer, defferedCreateTalentForEmployer) {
            const talentIds = [candidate.talentID];
            const { positionId } = recruiterCandidatesJobCtrl.$stateParams;
            const { result: profilesForSubmissions } = await TalentForEmployerService.isTalentForEmployerExist({ talentIds, positionId });
            const profileForSubmission = profilesForSubmissions[candidate.talentID];
            if (profileForSubmission) {
                if (defferedCreateTalentForEmployer) {
                    defferedCreateTalentForEmployer.resolve(true);
                }
                return;
            }
            return recruiterCandidatesJobCtrl.createResumeForEmployer.apply(this, arguments);
        };

        recruiterCandidatesJobCtrl.createResumeForEmployer = async function (
            candidate,
            openCandidates,
            talentForEmployer,
            defferedCreateTalentForEmployer,
        ) {
            if (candidate.createResumeBlocked) {
                return;
            }
            candidate.createResumeBlocked = true;
            if (talentForEmployer) {
                if (!talentForEmployer.candidateData) {
                    talentForEmployer = {
                        candidateData: talentForEmployer,
                    };
                }
                talentForEmployer.candidateData.positionId = $stateParams.positionId;
                const id = talentForEmployer.candidateData._id;
                delete talentForEmployer.candidateData._id;
                try {
                    const response = await TalentForEmployerService.addTalentForEmployer(talentForEmployer.candidateData);
                    talentForEmployer.candidateData._id = id;
                    const workflow = _.find(recruiterCandidatesJobCtrl.positionData.workflowData.data, { talentId: candidate.talentID });

                    if (workflow) {
                        await WorkflowService.postWorkflowEvent(workflow._id, {
                            eventType: WorkflowService.eventTypes.RESUME_CREATED,
                            content: {
                                message: `talent Expert ${recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.fullName} created ResumeForEmployer`,
                            },
                            entityId: response.result._id,
                            recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                        });
                    }

                    candidate.createResumeBlocked = false;
                    if (defferedCreateTalentForEmployer) {
                        defferedCreateTalentForEmployer.resolve(true);
                        return;
                    }
                    $sessionStorage.candidateTab = 'talent_for_employer';
                    $state.go($state.current.name, {
                        workflowStep: recruiterCandidatesJobCtrl.workflow,
                        talentID: candidate.talentID,
                    }, { reload: $state.current.name });
                } catch (error) {
                    candidate.createResumeBlocked = false;
                    talentForEmployer.candidateData._id = id;
                    Logger.error(error);
                }
            } else {
                candidate.createResumeBlocked = false;
            }
        };

        recruiterCandidatesJobCtrl.createTalentForEmployerIfNoExists = async ({
            candidate,
            talentForEmployer,
        }) => {
            const talentIds = [candidate.talentID];
            const { positionId } = recruiterCandidatesJobCtrl.$stateParams;
            const { result: profilesForSubmissions } = await TalentForEmployerService.isTalentForEmployerExist({
                talentIds,
                positionId,
            });
            const profileForSubmission = profilesForSubmissions[candidate.talentID];
            if (profileForSubmission) {
                return;
            }
            return recruiterCandidatesJobCtrl.createTalentForEmployer({
                candidate,
                talentForEmployer,
            });
        };

        recruiterCandidatesJobCtrl.createTalentForEmployer = async ({
            candidate,
            talentForEmployer,
        }) => {
            if (candidate.createResumeBlocked) {
                return;
            }
            candidate.createResumeBlocked = true;
            if (talentForEmployer) {
                if (!talentForEmployer.candidateData) {
                    talentForEmployer = {
                        candidateData: talentForEmployer,
                    };
                }
                talentForEmployer.candidateData.positionId = $stateParams.positionId;
                const id = talentForEmployer.candidateData._id;
                delete talentForEmployer.candidateData._id;
                try {
                    const response = await TalentForEmployerService.addTalentForEmployer(talentForEmployer.candidateData);
                    talentForEmployer.candidateData._id = id;
                    const workflow = _.find(recruiterCandidatesJobCtrl.positionData.workflowData.data, { talentId: candidate.talentID });

                    if (workflow) {
                        await WorkflowService.postWorkflowEvent(workflow._id, {
                            eventType: WorkflowService.eventTypes.RESUME_CREATED,
                            content: {
                                message: `talent Expert ${recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.fullName} created ResumeForEmployer`,
                            },
                            entityId: response.result._id,
                        });
                    }

                    candidate.createResumeBlocked = false;
                } catch (error) {
                    candidate.createResumeBlocked = false;
                    talentForEmployer.candidateData._id = id;
                    Logger.error(error);
                }
            } else {
                candidate.createResumeBlocked = false;
            }
        };

        recruiterCandidatesJobCtrl.updateInterview = function (candidate, openCandidates, currentInterview, field, newValue) {
            const newInterview = angular.copy(currentInterview);
            newInterview[field] = newValue;
            CandidateService.updateCandidateInterview(candidate.workflow.candidateId, newInterview._id, newInterview)
                .then(() => {
                    currentInterview[field] = newValue;
                })
                .catch(error => Logger.error(error));
        };

        $('.expand-icon')
            .click(() => {
                $('#sidebar-form-modal')
                    .modal('show');
            });

        recruiterCandidatesJobCtrl.sendResumeToCandidate = function (candidate, talentExpertMessage, otherEmails, subject) {
            const messageContent = {
                subject,
                body: talentExpertMessage,
                destinations: [
                    {
                        candidateId: candidate.workflow.candidateId,
                    },
                ],
                source: {
                    recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                },
                messageContext: {
                    positionId: $stateParams.positionId,
                    workflowId: candidate.workflow._id,
                },
            };
            let sent = false;
            if (otherEmails && otherEmails.length > 0) {
                for (let i = 0; i < otherEmails.length; i++) {
                    messageContent.destinations.push({
                        email: otherEmails[i],
                    });
                }
                sent = true;
            }

            if (sent) {
                MessageService.addMessage(messageContent);
            }
            /* ADD MESSAGE ENDS HERE */
            WorkflowService.postWorkflowEvent(candidate.workflow._id, {
                eventType: WorkflowService.eventTypes.TALENT_EXPERT_SENT_RESUME_TO_CANDIDATE,
                content: {
                    message: `Talent expert ${recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.fullName} send Resume To candidate`,
                },
                entityId: null,
                recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
            });
            $sessionStorage.candidateTab = 'talent_for_employer';
            $state.go($state.current.name, {
                workflowStep: recruiterCandidatesJobCtrl.workflow,
                talentID: candidate.talentID,
            }, { reload: true });
        };

        recruiterCandidatesJobCtrl.openClaimListPage = () => {
            $state.go($state.current.name, {
                workflowStep: RECRUITER_WORKFLOW_STATUS.CLAIMED,
                talentID: null,
                currCandidatePage: 1,
            }, { reload: $state.current.name });
        };

        recruiterCandidatesJobCtrl.openRequestFeedback = function () {
            $timeout(() => {
                $state.go($state.current.name, {
                    workflowStep: RECRUITER_WORKFLOW_STATUS.FEEDBACK,
                    talentID: null,
                    candidatesPage: 1,
                    feedbackFilterMode: null,
                }, { reload: true });
            }, 300);
        };

        recruiterCandidatesJobCtrl.setStartCase = function (fullname) {
            return _.chain(fullname)
                .toLower()
                .startCase()
                .value();
        };

        recruiterCandidatesJobCtrl.setStartCaseAndGetFirst = function (fullname) {
            return _.chain(recruiterCandidatesJobCtrl.setStartCase(fullname))
                .split(' ')
                .first()
                .value();
        };

        recruiterCandidatesJobCtrl.changeTemplateTags = function (
            templates,
            candidateData,
            recruiterData,
            positionData,
            type,
            channelType = CONTACT_CHANNEL_TYPES.EMAIL,
            employerRep,
        ) {
            return _.forEach(templates, (template) => {
                const isEmailChannelType = channelType === CONTACT_CHANNEL_TYPES.EMAIL;

                if (candidateData) {
                    const fullName = recruiterCandidatesJobCtrl.setStartCase(candidateData.fullName);
                    const [candidateFirstName, ...candidateLastName] = (candidateData.fullName || '').split(' ');
                    const firstName = recruiterCandidatesJobCtrl.setStartCase(candidateFirstName);
                    const lastName = recruiterCandidatesJobCtrl.setStartCase(candidateLastName);

                    template.template = template.template
                        .replaceAll(
                            '<span field=\'prospectName\'></span>',
                            `<span field='prospectName'>${fullName}</span>`,
                        )
                        .replaceAll(
                            '<span field=\'prospectFirstName\'></span>',
                            `<span field='prospectFirstName'>${fullName}</span>`,
                        )
                        .replaceAll(
                            '<span field=\'candidateFirstName\'></span>',
                            `<span field='candidateFirstName'>${firstName}</span>`,
                        )
                        .replaceAll(
                            '<span field=\'candidateLastName\'></span>',
                            `<span field='candidateLastName'>${lastName}</span>`,
                        );

                    if (type === 'profileEmployer') {
                        template.template = template.template.replaceAll('<a href=\'link\'>', '<a href="link" replace-key="TARGET_LINK">');
                    } else if (type === 'profileCandidate' && candidateData.talentForCandidateId) {
                        template.template = template.template.replaceAll(
                            '<a href=\'link\'>',
                            `<a href='${EnvSettings.Auth0RedirectUrl}#/candidateApproval/${candidateData.talentForCandidateId}/${candidateData.workflow._id}'>`);
                    }

                    if (candidateData.positionApprovalLink && !isEmailChannelType) {
                        template.template = template.template
                            .replaceAll(/<a(.*?)\s((field)|(href))=\\?['"]positionApproveLink\\?['"]>/, `${candidateData.positionApprovalLink} `);
                    }
                }

                if (recruiterData) {
                    template.template = template.template
                        .replaceAll(
                            '<span field=\'teName\'></span>',
                            `<span field='teName'>${recruiterCandidatesJobCtrl.setStartCase(recruiterData.fullName)}</span>`,
                        )
                        .replaceAll(
                            '<span field=\'teFirstName\'></span>',
                            `<span field='teFirstName'>${recruiterCandidatesJobCtrl.setStartCaseAndGetFirst(recruiterData.fullName)}</span>`,
                        );

                    if (recruiterData.contact.email.length > 0) {
                        template.template = template.template.replaceAll(
                            '<span field=\'teEmail\'></span>',
                            `<span field='teEmail'>${Recruiter.getEmail(recruiterData)}</span>`,
                        );
                    }

                    if (recruiterData.contact.phone.length > 0) {
                        template.template = template.template.replaceAll(
                            '<span field=\'tePhone\'></span>',
                            `<span field='tePhone'>${recruiterData.contact.phone[0].value}</span>`,
                        );
                    }
                }

                if (positionData) {
                    const locationsString = (positionData.locations || [])
                        .map(location => CommonCodeService.getLocationString(location))
                        .join(' OR ');

                    template.template = template.template
                        .replaceAll(
                            '<span field=\'jobTitle\'></span>',
                            `<span field='jobTitle'>${recruiterCandidatesJobCtrl.setStartCase(positionData.jobTitle)}</span>`,
                        )
                        .replaceAll(
                            '<span field=\'employerName\'></span>',
                            `<span field='employerName'>${recruiterCandidatesJobCtrl.setStartCase(positionData.employerData.name)}</span>`,
                        )
                        .replaceAll(
                            '<span field=\'employerCompanyWebsite\'></span>',
                            `<a field='employerCompanyWebsite' target="_blank">${_.get(positionData, 'employerData.contact.webAddress.0.value', '')}</a>`,
                        )
                        .replaceAll(
                            '<span field=\'location\'></span>',
                            `<span field='location'>${positionData.locationString}</span>`,
                        )
                        .replaceAll(
                            '<span field=\'positionLocation\'></span>',
                            `<span field='positionLocation'>${locationsString}</span>`,
                        );

                    if (type === 'profilesEmployer' || type === 'feedbackEmployer') {
                        template.template = template.template.replaceAll('<a href=\'link\'>', '<a href="link" replace-key="TARGET_LINK">');
                    }

                    if (employerRep) {
                        template.template = template.template
                            .replaceAll(
                                '<span field=\'employerRepName\'></span>',
                                `<span field='employerRepName'>${employerRep.name}</span>`,
                            )
                            .replaceAll(
                                '<span field=\'employerRepEmail\'></span>',
                                `<span field='employerRepEmail'>${employerRep.email}</span>`,
                            )
                            .replaceAll(
                                '<span field=\'employerRepPhone\'></span>',
                                `<span field='employerRepPhone'>${_.get(employerRep, 'phones.0.value', '')}</span>`,
                            )
                            .replaceAll(
                                '<span field=\'employerRepJobTitle\'></span>',
                                `<span field='employerRepJobTitle'>${_.get(employerRep, 'title', '')}</span>`,
                            );
                    }
                }

                if (template.subject) {
                    if (candidateData) {
                        const fullName = recruiterCandidatesJobCtrl.setStartCase(candidateData.fullName);
                        const [candidateFirstName, ...candidateLastName] = (candidateData.fullName || '').split(' ');
                        const firstName = recruiterCandidatesJobCtrl.setStartCase(candidateFirstName);
                        const lastName = recruiterCandidatesJobCtrl.setStartCase(candidateLastName);

                        template.subject = template.subject.replaceAll(
                            '<span field=\'prospectName\'></span>',
                            `<span field='prospectName'>${fullName}</span>`,
                        ).replaceAll(
                            '<span field=\'prospectFirstName\'></span>',
                            `<span field='prospectFirstName'>${fullName}</span>`,
                        ).replaceAll(
                            '<span field=\'candidateFirstName\'></span>',
                            `<span field='candidateFirstName'>${firstName}</span>`,
                        ).replaceAll(
                            '<span field=\'candidateLastName\'></span>',
                            `<span field='candidateLastName'>${lastName}</span>`,
                        );

                        if (type === 'profileEmployer') {
                            template.subject = template.subject.replaceAll('<a href=\'link\'>', '<a href="link" replace-key="TARGET_LINK">');
                        }
                    }

                    if (recruiterData) {
                        template.subject = template.subject
                            .replaceAll(
                                '<span field=\'teName\'></span>',
                                `<span field='teName'>${recruiterCandidatesJobCtrl.setStartCase(recruiterData.fullName)}</span>`,
                            )
                            .replaceAll(
                                '<span field=\'teFirstName\'></span>',
                                `<span field='teFirstName'>${recruiterCandidatesJobCtrl.setStartCaseAndGetFirst(recruiterData.fullName)}</span>`,
                            );

                        if (recruiterData.contact.email.length > 0) {
                            template.subject = template.subject.replaceAll(
                                '<span field=\'teEmail\'></span>',
                                `<span field='teEmail'>${Recruiter.getEmail(recruiterData)}</span>`,
                            );
                        }

                        if (recruiterData.contact.phone.length > 0) {
                            template.subject = template.subject.replaceAll(
                                '<span field=\'tePhone\'></span>',
                                `<span field='tePhone'>${recruiterData.contact.phone[0].value}</span>`,
                            );
                        }
                    }

                    if (positionData) {
                        const locationsString = (positionData.locations || [])
                            .map(location => CommonCodeService.getLocationString(location))
                            .join(' OR ');

                        template.subject = template.subject
                            .replaceAll(
                                '<span field=\'jobTitle\'></span>',
                                `<span field='jobTitle'>${recruiterCandidatesJobCtrl.setStartCase(positionData.jobTitle)}</span>`,
                            )
                            .replaceAll(
                                '<span field=\'employerName\'></span>',
                                `<span field='employerName'>${recruiterCandidatesJobCtrl.setStartCase(positionData.employerData.name)}</span>`,
                            )
                            .replaceAll(
                                '<span field=\'employerCompanyWebsite\'></span>',
                                `<span field='employerCompanyWebsite'>${_.get(positionData, 'employerData.contact.webAddress.0.value', '')}</span>`,
                            )
                            .replaceAll(
                                '<span field=\'location\'></span>',
                                `<span field='location'>${locationsString}</span>`,
                            )
                            .replaceAll(
                                '<span field=\'positionLocation\'></span>',
                                `<span field='positionLocation'>${locationsString}</span>`,
                            );

                        if (type === 'profilesEmployer' || type === 'feedbackEmployer') {
                            template.subject = template.subject.replaceAll('<a href=\'link\'>', '<a href="link" replace-key="TARGET_LINK">');
                        }
                    }

                    if (employerRep) {
                        template.template = template.template
                            .replaceAll(
                                '<span field=\'employerRepName\'></span>',
                                `<span field='employerRepName'>${employerRep.name}</span>`,
                            )
                            .replaceAll(
                                '<span field=\'employerRepEmail\'></span>',
                                `<span field='employerRepEmail'>${employerRep.email}</span>`,
                            )
                            .replaceAll(
                                '<span field=\'employerRepPhone\'></span>',
                                `<span field='employerRepPhone'>${_.get(employerRep, 'phones.0.value', '')}</span>`,
                            )
                            .replaceAll(
                                '<span field=\'employerRepJobTitle\'></span>',
                                `<span field='employerRepJobTitle'>${_.get(employerRep, 'title', '')}</span>`,
                            );
                    }
                }
            });
        };

        recruiterCandidatesJobCtrl.openModalOfSendFeedbackToEmployer = async function () {
            if (!recruiterCandidatesJobCtrl.canSendToEmployer || recruiterCandidatesJobCtrl.sendToEmployerDisabled) {
                return;
            }

            try {
                const employerRep = null;

                RecruiterService.getRecruiter(recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id)
                    .then((response) => {
                        const recruiterData = response.result;
                        let language = RouteService.getUserPreference('uiLanguage');
                        if (!language) {
                            language = 'en-US';
                        }
                        RouteService.getEmailTemplates(language, 'feedbackEmployer')
                            .then((response) => {
                                recruiterCandidatesJobCtrl.contactUserTemplates = [];
                                recruiterCandidatesJobCtrl.userData = {
                                    positionData: recruiterCandidatesJobCtrl.positionData,
                                    candidateData: null,
                                    employerRep,
                                    emailType: 'employer',
                                };
                                if (response.result && response.result.templates) {
                                    recruiterCandidatesJobCtrl.contactUserTemplates = recruiterCandidatesJobCtrl.changeTemplateTags(
                                        response.result.templates, null,
                                        recruiterData, recruiterCandidatesJobCtrl.positionData, response.result.type,
                                    );
                                }
                                recruiterCandidatesJobCtrl.modalDialog = true;
                                $('#recruiterFeedbackModalDialog')
                                    .modal('show');
                            })
                            .catch(error => Logger.error(error));
                    })
                    .catch(error => Logger.error(error));
            } catch (error) {
                Logger.error(error);
            }
        };

        recruiterCandidatesJobCtrl.closeModalDialog = function () {
            $('#recruiterFeedbackModalDialog')
                .modal('hide');
            recruiterCandidatesJobCtrl.modalDialog = false;
        };

        recruiterCandidatesJobCtrl.viewFeedbackCandidate = function (workflow) {
            $state.go($state.current.name, {
                workflowStep: RECRUITER_WORKFLOW_STATUS.FEEDBACK,
                talentID: workflow.talentId,
            }, { reload: true });
        };

        recruiterCandidatesJobCtrl.initEmailData = function () {
            recruiterCandidatesJobCtrl.emailData = [];
            for (let i = 0; i < recruiterCandidatesJobCtrl.positionData.contact.email.length; i++) {
                recruiterCandidatesJobCtrl.emailData.push(recruiterCandidatesJobCtrl.positionData.contact.email[i].value);
            }
        };

        recruiterCandidatesJobCtrl.initActivityTab = async (candidate) => {
            try {
                const apiData = {
                    messageContext: {
                        positionId: $stateParams.positionId,
                        workflowId: candidate.workflow._id,
                    },
                    destinations: [],
                };

                let response = await MessageService.searchMessage(apiData);
                const messages = _.get(response, 'result', []);
                const involvedRecruterIds = _.map(messages, 'source.recruiterId');
                response = await RecruiterService.postRecruiterSearch({ recruiterIDs: involvedRecruterIds });
                const recruiters = _.get(response, 'result', []);
                const recruitersMap = _.keyBy(recruiters, '_id');
                for (const message of messages) {
                    const recruiterId = _.get(message, 'source.recruiterId');
                    const recruiter = _.get(recruitersMap, recruiterId);
                    _.set(message, 'source.recruiterData', recruiter);
                }
                candidate.activities = messages.reverse();
                $scope.$apply();
            } catch (error) {
                Logger.error(error);
            }
        };

        recruiterCandidatesJobCtrl.refreshSearch = function (claimedByOtherRecruiters) {
            if ($state.current.name == 'recruiter.candidatesJob') {
                $state.go('recruiter.candidatesJob', {
                    claimedByOtherTE: claimedByOtherRecruiters,
                }, {
                    reload: 'recruiter.candidatesJob',
                });
            }
        };

        recruiterCandidatesJobCtrl.moveProspectToReady = function (candidate, openCandidate, canClaim, nextCandidate) {
            if (!canClaim) {
                NotificationService.error('You have reached the maximum number of claimed candidates');
                return;
            }
            if (candidate.workflow) {
                WorkflowService.putRecruiterWorkflowStatus(candidate.workflow._id, {
                    status: 'Ready',
                    reason: 'N/A',
                    details: {
                        recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                    },
                })
                    .catch(error => Logger.error(error));
            } else {
                const deffered = $q.defer();
                $scope.addWorkflow(candidate.candidateData._id, candidate, deffered)
                    .then((workflow) => {
                        if (workflow) {
                            WorkflowService.putRecruiterWorkflowStatus(workflow._id, {
                                status: 'Ready',
                                reason: 'N/A',
                                details: {
                                    recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                                },
                            })
                                .then((response) => {
                                    candidate.workflow = response.result;
                                })
                                .catch(error => Logger.error(error));
                        }
                    })
                    .catch(error => Logger.error(error));
            }
            const defferedCreateTalentForEmployer = $q.defer();
            defferedCreateTalentForEmployer.promise.then(() => {
                nextCandidate(true);
            })
                .catch(error => Logger.error(error));
            recruiterCandidatesJobCtrl.createResumeForEmployer(candidate, openCandidate, candidate, defferedCreateTalentForEmployer);
        };

        recruiterCandidatesJobCtrl.sendLinkedinMessageToCandidate = function (candidate, summary, selectedMessage, callback) {
            const msg = candidate.msgContent || '';

            if (candidate.checkLinkedin && window.TE && window.TE.sendMessage) {
                return new Promise((resolve) => {
                    const messageLinkedinContent = {
                        subject: 'Contact Candidate',
                        body: candidate.msgContent,
                        destinations: [],
                        source: {
                            recruiterId: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData._id,
                        },
                        messageContext: {
                            positionId: $stateParams.positionId,
                            workflowId: candidate.workflow._id,
                        },
                    };

                    const linkedinUrl = _.find(candidate.candidateData.contact.webAddress, { type: 'linkedin' });

                    if (linkedinUrl) {
                        const defferedContactEvent = $q.defer();

                        window.TE.onMessageSent = function (data) {
                            if (data.statusCode === 1) {
                                CandidatesContactService.addCandidateContactCampaignSentMessage({
                                    contactType: 'auto',
                                    sentMessage: selectedMessage,
                                    positionId: $stateParams.positionId,
                                    talentId: candidate.talentID,
                                });

                                MessageService.addMessage(messageLinkedinContent);

                                NotificationService.success('CHROME_EXTENSION_SUCCESS_NOTIFCATION');

                                if (candidate.checkLinkedin) {
                                    recruiterCandidatesJobCtrl.sendMsgAddContactEvent({
                                        candidate,
                                        msg,
                                        type: CONTACT_MODE_TYPES.LINKEDIN_MESSAGE,
                                        deffered: defferedContactEvent,
                                    });
                                }
                                $timeout(() => summary.sent++);
                            } else if (data.statusCode === 4) {
                                NotificationService.error('CHROME_EXTENSION_FAILED_NOTIFCATION');
                                $timeout(() => summary.failed++);
                            } else if (data.statusCode === 5) {
                                MessageService.addMessage(messageLinkedinContent);
                                NotificationService.success('CHROME_EXTENSION_SEND_INVATION_AND_MESSAGE');
                                if (candidate.checkLinkedin) {
                                    recruiterCandidatesJobCtrl.sendMsgAddContactEvent({
                                        candidate,
                                        msg,
                                        type: CONTACT_MODE_TYPES.LINKEDIN_MESSAGE,
                                        deffered: defferedContactEvent,
                                    });
                                }
                                $timeout(() => summary.sent++);
                            } else if (data.statusCode === 6) {
                                NotificationService.error('CHROME_EXTENSION_CANNOT_SEND_INVATION_IS_TOO_LONG');
                                $timeout(() => summary.failed++);
                            } else if (data.statusCode === 7) {
                                NotificationService.error('CHROME_EXTENSION_INVATION_ALREADY_SENT');
                                $timeout(() => summary.failed++);
                            } else {
                                NotificationService.error('CHROME_EXTENSION_FAILED_NOTIFCATION');
                                $timeout(() => summary.failed++);
                            }

                            resolve();
                            if (_.isFunction(callback)) {
                                callback();
                            }
                        };

                        const linkedinMsg = EmailService.cleanUpSpecificHTMLTags(candidate.msgContent);
                        window.TE.sendMessage(linkedinMsg, linkedinUrl.url);
                        messageLinkedinContent.destinations.push({
                            linkedin: linkedinUrl.url,
                        });

                        messageLinkedinContent.destinations.push({
                            candidateId: _.get(candidate, 'workflow.candidateId'),
                        });
                    }
                });
            }

            if (_.isFunction(callback)) {
                callback();
            }

            return Promise.resolve();
        };

        recruiterCandidatesJobCtrl.contactUser = async function (type, contactData) {
            const innerType = type.type;
            const subject = EmailService.cleanUpSpecificHTMLTags(contactData.subject);

            if (['feedback', 'resume', 'resumes'].includes(innerType)) {
                contactData.content = recruiterCandidatesJobCtrl.getReplacedLink(contactData.content);
            }

            if (!_.isEmpty(contactData.email)) {
                const recruiterEmail = Recruiter.getEmail(recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData);
                let recruiterPhone = '';
                if (recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.contact.phone.length > 0) {
                    recruiterPhone = recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.contact.phone[0].value;
                }

                try {
                    const sendEmailCallbackAsync = async ({ isValidationRequest = false } = {}) => {
                        if (innerType === 'candidate') {
                            await RouteService.sendContactCandidateMail({
                                from: 'talentExperts',
                                body: contactData.content,
                                to: contactData.email,
                                subject,
                                talentExpertName: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.fullName,
                                talentExpertEmail: recruiterCandidatesJobCtrl.operationalEmailSender || recruiterEmail,
                                talentExpertCellPhone: recruiterPhone,
                            });

                            recruiterCandidatesJobCtrl.sendResumeToCandidate(
                                contactData.candidate,
                                contactData.content,
                                contactData.email,
                                subject,
                            );
                        } else {
                            let actionType = null;

                            if (innerType === 'feedback') {
                                actionType = EMPLOYER_REP_AUTH_FLOW.FEEDBACK;
                            } else if (innerType === 'resume' || innerType === 'resumes') {
                                actionType = EMPLOYER_REP_AUTH_FLOW.SUBMIT_TO_EMPLOYER;
                            }

                            const params = {
                                emails: contactData.email,
                                actionType,
                                employerId: this.userdata.positionData.employerId,
                                positionId: this.userdata.positionData._id,
                                emailObj: {
                                    from: 'talentExperts',
                                    host: `${EnvSettings.Auth0RedirectUrl}`,
                                    body: contactData.content,
                                    to: contactData.email,
                                    subject,
                                    talentExpertName: recruiterCandidatesJobCtrl.recruiterCtrl.recruiterData.fullName,
                                    talentExpertEmail: recruiterEmail,
                                    talentExpertCellPhone: recruiterPhone,
                                },
                                innerType,
                                talentId: _.get(contactData, 'candidate.talentID'),
                            };

                            const { result: sendingResults } = await RouteService.sendEmployerRepMail({
                                ...params,
                                isValidationRequest,
                            }) || {};
                            return {
                                validationResults: sendingResults,
                                actionType,
                            };
                        }
                    };

                    const isNeedToValidateEmailsFirst = innerType !== 'candidate';
                    if (isNeedToValidateEmailsFirst) {
                        const { validationResults, actionType } = await sendEmailCallbackAsync({ isValidationRequest: true });

                        if (validationResults && validationResults.isErr) {
                            recruiterCandidatesJobCtrl.showConfirmErrorEmailMessage(validationResults, actionType);
                            $scope.$apply();
                            return;
                        }
                    }

                    if (['resume', 'resumes'].includes(innerType)) {
                        if (innerType === 'resumes') {
                            contactData.closeModal();
                        }

                        const candidatesToSend = _.get(contactData, 'candidates', [contactData.candidate]) || [];
                        if (_.isEmpty(candidatesToSend)) {
                            return;
                        }

                        const promises = [];
                        for (const candidate of candidatesToSend) {
                            promises.push(
                                $scope.updateWorkFlowStatusesV2({
                                    candidate,
                                    status: RECRUITER_WORKFLOW_STATUS.SENT,
                                    reason: 'N/A',
                                }),
                            );
                            if (contactData.isneedcreateprofiles) {
                                promises.push(
                                    recruiterCandidatesJobCtrl.createTalentForEmployerIfNoExists({
                                        candidate,
                                        talentForEmployer: candidate,
                                    }),
                                );
                            }
                        }
                        await Promise.all(promises);
                        await sendEmailCallbackAsync();
                        $state.go($state.current.name, {
                            workflowStep: RECRUITER_WORKFLOW_STATUS.SENT,
                        }, { reload: true });
                    } else if (innerType === 'feedback') {
                        await recruiterCandidatesJobCtrl.sendFeedbackToEmployer();
                        await sendEmailCallbackAsync();
                    } else {
                        await sendEmailCallbackAsync();
                    }
                } catch (error) {
                    Logger.error(error);
                }
            }
        };

        recruiterCandidatesJobCtrl.onClaimSuccess = function onClaimSuccess() {
            $scope.getPosition();
        };
    }

    getReplacedLink(content = '') {
        return content.replace(new RegExp(LINK_TAG_REGEX, 'g'), '<a href="link" replace-key="TARGET_LINK">');
    }

    showConfirmErrorEmailMessage(sendingResults, actionType) {
        const { messages = [] } = sendingResults;
        const prefix = actionType === 'FEEDBACK' ? 'FEEDBACK_REQUEST' : 'SEND_TO_EMPLOYER';
        messages.map((item) => {
            const postfix = item.email.replace('@', '')
                .replace(/\./gi, '');
            if (item.errType === 'inactiveEmployerRep') {
                const details = `${prefix}_EMAIL_ALERT_MESSAGE_INACTIVE`;
                return {
                    modalDialogId: `confirmEmailError${postfix}`,
                    body: `${item.email} ${this.$filter('translate')(details)}`,
                };
            }
            if (item.errType === 'inactiveRecruiter') {
                const details = `${prefix}_EMAIL_ALERT_MESSAGE_INACTIVE`;
                return {
                    modalDialogId: `confirmEmailError${postfix}`,
                    body: `${item.email} ${this.$filter('translate')(details)}`,
                };
            }
            if (item.errType === 'notBelongsToEmployer') {
                const details = `${prefix}_EMAIL_ALERT_MESSAGE_OTHER_EMPLOYER`;
                const opts = {
                    modalDialogId: `confirmEmailError${postfix}`,
                    body: `${item.email} ${this.$filter('translate')(details)}`,
                };

                return opts;
            }
        })
            .forEach((opts, index) => {
                const header = `${prefix}_EMAIL_ALERT_HEADER`;
                const baseOpts = {
                    title: `${this.$filter('translate')(header)}`,
                    customZIndex: 100000,
                    cancelLabelKey: 'OK',
                    showCancelButton: true,
                    showCloseButton: false,
                    buttons: [],
                };
                baseOpts.customZIndex += index;

                this.ModalDialogService.showDialog(Object.assign({}, baseOpts, opts));
            });
    }

    async multiRejectCandidates(candidates) {
        const candidateIds = candidates.filter(({ workflow }) => workflow)
            .map(({ workflow }) => workflow.candidateId);
        const positionId = this.positionData._id;

        try {
            await this.WorkflowService.bulkRejectOnRecruiterSide({ candidateIds, positionId })
                .then(() => {
                    const candidatesToRemoveRequestFeedback = [];
                    for (const oneCandidate of candidates) {
                        const isGoodRated = _.get(oneCandidate, 'workflow.feedback.grades[0].grade', 0) === 1;
                        if (isGoodRated) {
                            this.WorkflowService.putEmployerWorkflowStatus(oneCandidate.workflow._id, {
                                status: EMPLOYER_WORKFLOW_STATUS.REJECTED,
                                reason: 'N/A',
                            });
                        } else {
                            candidatesToRemoveRequestFeedback.push(oneCandidate);
                            const talentId = _.get(oneCandidate, 'workflow.talentId');
                            this.PositionService.deletePositionFeedback(positionId, { talentId });
                        }

                        if (!_.isEmpty(candidatesToRemoveRequestFeedback)) {
                            this.RecruiterFeedbackService.multiRemoveRequestFeedback(positionId, candidatesToRemoveRequestFeedback);
                        }
                    }
                });
            this.$timeout(() => {
                this.NotificationService.success('BULK_REJECT_SUCCESS_NOTIFICATION');
                this.$state.reload();
            });
        } catch (error) {
            this.NotificationService.error('BULK_REJECT_ERROR_NOTIFICATION');
            Logger.error('Error on reject caniddates', error);
        }
    }

    onCandidateClick(candidate) {
        this.$state.go('recruiter.candidatesJob', {
            talentID: candidate.talentID,
        });
    }

    onCandidateCheck() {
        this.selectedPartially = (this.getSelectedFeedbackCandidates() || []).length > 0;
        this.isFeedbackButtonVisible = this.getFeedbackButtonsVisibilityState(this.selectedAll, this.selectedPartially);
        this.isExportCsvVisible = this.getExportCsvDisplayState(this.selectedAll, this.selectedPartially);
        this.isBulkClaimVisible = this.getBulkClaimDisplayState(this.selectedAll, this.selectedPartially);
    }

    toggleSelectAllFeedbackCandidatesState(newState) {
        this.selectedAll = newState;
        this.selectedPartially = false;
        const candidates = this.filteredCandidatesList;

        for (const candidate of candidates) {
            candidate.check = newState;
        }

        this.isFeedbackButtonVisible = this.getFeedbackButtonsVisibilityState(this.selectedAll, this.selectedPartially);
        this.isExportCsvVisible = this.getExportCsvDisplayState(this.selectedAll, this.selectedPartially);
        this.isBulkClaimVisible = this.getBulkClaimDisplayState(this.selectedAll, this.selectedPartially);
    }

    getFeedbackButtonsVisibilityState(selectedAll, selectedPartially) {
        return (selectedAll || selectedPartially) && (this.workflow !== EMPLOYER_WORKFLOW_STATUS.SAMPLES);
    }

    getExportCsvDisplayState(selectedAll, selectedPartially) {
        const isListEmpty = !_.get(this.filteredCandidatesList, 'length', 0);
        const isCandidatesSelected = selectedAll || selectedPartially;

        return !isListEmpty && isCandidatesSelected;
    }

    getBulkClaimDisplayState(selectedAll, selectedPartially) {
        const isListEmpty = !_.get(this.filteredCandidatesList, 'length', 0);
        const isCandidatesSelected = selectedAll || selectedPartially;
        const isFeedbackTab = this.workflow === RECRUITER_WORKFLOW_STATUS.FEEDBACK;

        return isFeedbackTab && !isListEmpty && isCandidatesSelected;
    }

    getSelectedFeedbackCandidates() {
        return this.filteredCandidatesList.filter(({ check }) => check);
    }

    async requestFeedback(candidate, nextCandidate) {
        try {
            const { _id: positionId } = this.positionData;

            await this.RecruiterFeedbackService.requestFeedback(positionId, candidate);

            nextCandidate(true, { stayOnLast: true });
        } catch (error) {
            Logger.error(error);
        }
    }

    async removeCandidateFromFeedback(candidate, nextCandidate) {
        try {
            const { _id: positionId } = this.positionData;

            await this.RecruiterFeedbackService.removeRequestFeedback(positionId, candidate);

            nextCandidate(true, { stayOnLast: true });
        } catch (error) {
            Logger.error(error);
        }
    }

    async sendFeedbackToEmployer() {
        const resultList = _.get(this, 'positionData.workflowData.requestFeedback.added.resultList');

        // here comes shame part of code, -- todo refactor please
        // get candidate without workflow and fetch workflow it by talentId
        const candidatesWOWorkflow = _.remove(resultList, ({ workflow }) => !workflow);
        const promList = _.map(candidatesWOWorkflow, candidate => this.WorkflowService.getWorkflowSearch({ talentId: candidate.talentId })
            .then(({ result }) => result)
            .then(_.first)
            .then(workflow => ({
                ...candidate,
                workflow,
            })));

        const fetchPromisesList = async prom => Promise.all(prom);
        const candidatesWithFetchedWorkflow = await fetchPromisesList(promList);

        // set feedback to workflow for candidates for those we fetched workflow above
        const feedbackOnCandidatesByTalentId = _.keyBy(this.positionData.feedbackOnCandidates, 'talentId');
        _.forEach(candidatesWithFetchedWorkflow, (candidate) => {
            const feedbackOnCandidate = feedbackOnCandidatesByTalentId[candidate.talentId];
            candidate.workflow.feedback = (feedbackOnCandidate || { status: CANDIDATE_FEEDBACK_STATUSES.READY_FOR_SEND });
        });

        // get collection of profiles that are need to be sent to employer for feedback
        const feedbackProfiles = _(resultList)
            .concat(candidatesWithFetchedWorkflow)
            .filter(({ workflow }) => workflow.feedback.status === CANDIDATE_FEEDBACK_STATUSES.READY_FOR_SEND)
            .map(feedback => ({
                candidateId: feedback.workflow.candidateId,
                employerRepId: this.positionData.employerId,
                status: CANDIDATE_FEEDBACK_STATUSES.PENDING,
            }))
            .value();

        if (feedbackProfiles.length > 0) {
            try {
                const { _id: positionId } = this.positionData;
                await this.RecruiterFeedbackService.sendFeedbackToEmployer(positionId, feedbackProfiles);

                this.positionData.feedbackOnCandidates = feedbackProfiles;
                this.$localStorage.positionData = null;
            } catch (error) {
                Logger.error(error);
            }
        }

        this.closeModalDialog();
        this.openRequestFeedback();
    }

    async multiRequestFeedback(candidates) {
        try {
            const { _id: positionId } = this.positionData;
            const { none: candidatesWithoutFeedback } = this.RecruiterFeedbackService.getFeedbackStatisticsForCandidates(candidates);

            if (candidatesWithoutFeedback.length !== 0) {
                await this.RecruiterFeedbackService.multiRequestFeedback(positionId, candidatesWithoutFeedback);

                this.NotificationService.success('REQUEST_FEEDBACK_BULK_SUCCESS_MESSAGE');

                this.$state.reload();
            } else {
                this.NotificationService.success('REQUEST_FEEDBACK_BULK_NOT_RELEVANT_MESSAGE');
            }
        } catch (error) {
            Logger.error(error);
        }
    }

    async multiRemoveRequestFeedback() {
        const { _id: positionId } = this.positionData;
        const candidates = this.getSelectedFeedbackCandidates();
        const { allCount, readyForSend } = this.RecruiterFeedbackService.getFeedbackStatisticsForCandidates(candidates);

        if (readyForSend.length === 0) {
            this.toggleSelectAllFeedbackCandidatesState(false);

            return this.NotificationService.error('BULK_REMOVE_FROM_FEEDBACK_MESSAGE_NONE');
        }
        const isAllCandidatesReadyForSend = readyForSend.length === allCount;
        const body = isAllCandidatesReadyForSend ? 'BULK_REMOVE_FROM_FEEDBACK_MESSAGE_ALL' : 'BULK_REMOVE_FROM_FEEDBACK_MESSAGE_PARTIAL';
        const notificationMessage = isAllCandidatesReadyForSend ? 'BULK_REMOVE_FROM_FEEDBACK_REMOVE_ALL_SUCCESS' : 'BULK_REMOVE_FROM_FEEDBACK_REMOVE_PARTIAL_SUCCESS';

        return this.ModalDialogService.showDialog({
            modalDialogId: 'multiRemoveRequestFeedback',
            title: 'BULK_REMOVE_FROM_FEEDBACK_HEADER',
            body,
            showCancelButton: true,
            showCloseButton: false,
            buttons: [{
                label: 'BULK_REMOVE_FROM_FEEDBACK_REMOVE_ALL',
                className: 'primary-button',
                onClick: async () => {
                    try {
                        await this.RecruiterFeedbackService.multiRemoveRequestFeedback(positionId, readyForSend);
                        this.NotificationService.success(notificationMessage);
                        this.$state.reload();
                    } catch (error) {
                        Logger.error(error);
                    }
                },
            }],
        });
    }

    onShowSamplesButtonClick() {
        this.$state.go(this.$state.current.name, {
            workflowStep: 'Samples',
        });
    }

    onShowFeedbackProfilesButtonClick({ isFeedbackToSamplesRedirectIfEmpty = true } = {}) {
        this.$state.go(this.$state.current.name, {
            workflowStep: 'Feedback',
            isFeedbackToSamplesRedirectIfEmpty,
        });
    }

    getFilteredCandidatesList() {
        if (this.workflow === 'Samples') {
            return this.manuallyAddedSamples;
        }

        return this.positionData.workflowData.requestFeedback.added.resultList;
    }

    async fetchCanGenerateAutoFeedback() {
        try {
            this.requestFeedbackButtonLoading = true;

            this.canGenerateAutoFeedbackCandidates = await this.PositionService.canGenerateAutoFeedbackCandidates(this.$stateParams.positionId);
        } catch (error) {
            Logger.error(error);
        } finally {
            this.requestFeedbackButtonLoading = false;
            this.$scope.$apply();
        }
    }

    onFeedbackFilterStateChange(newFeedbackFilterState) {
        this.positionData.workflowData.requestFeedback.added.resultList = [];
        this.positionData.workflowData.requestFeedback.added.resultListLength = 0;
        this.candidatesWithFeedback = [];
        this.canFetchMoreFeedbackCandidates = true;
        this.feedbackFilterState = newFeedbackFilterState;
        this.feedbackFilterMode = _.get(newFeedbackFilterState, 'selected');

        this.toggleSelectAllFeedbackCandidatesState(false);

        this.fetchFeedbackCandidatesMore(DefaultFeedbackPageOptions, newFeedbackFilterState);
    }

    onFetchFeedbackCandidatesMore(newPageOptions) {
        if (!this.canFetchMoreFeedbackCandidates) {
            return;
        }

        this.fetchFeedbackCandidatesMore(newPageOptions, this.feedbackFilterState);
    }

    async fetchFeedbackCandidatesMore(pageOptions, feedbackFilterState) {
        try {
            const positionId = _.get(this, 'positionData._id', null);
            const recruiterId = _.get(this, 'recruiterCtrl.recruiterData._id', null);

            this.isFeedbackCandidatesLoading = true;

            const { list, total, counters, talentIds } = await this.RecruiterFeedbackService.getFeedbackCandidates({
                positionId,
                recruiterId,
                isListView: false,
                pageOptions: {
                    page: pageOptions.page,
                    skip: pageOptions.skip,
                    size: pageOptions.size,
                },
                filter: {
                    selected: feedbackFilterState.selected,
                },
            });

            let selectedFilter = feedbackFilterState.selected;

            this.feedbackListPageOptions = { ...pageOptions, total };
            this.feedbackFilterState = { selected: feedbackFilterState.selected, counters };
            this.feedbackCounters = { ...this.feedbackCounters, ...counters };

            if (counters.all) {
                if (selectedFilter === COUNTER_NON_RATED && counters.nonRated === 0) {
                    selectedFilter = COUNTER_ALL;
                }

                if (selectedFilter !== feedbackFilterState.selected) {
                    await this.fetchFeedbackCandidatesMore(pageOptions, {
                        selected: selectedFilter,
                        counters: {
                            all: 0,
                            nonRated: 0,
                            goodFit: 0,
                            notFit: 0,
                        },
                    });
                    return;
                }
            }

            const candidates = (list || [])
                .map(candidate => this.RecruiterCandidateService.getPreparedCandidate(
                    candidate,
                    this.recruiters,
                    this.allSamples,
                    this.unselectedSamples,
                ))
                .map(candidate => this.CandidateService.extendFeedbackData(candidate, this.feedbackProviders));

            if (this.positionData.workflowData.requestFeedback.added.resultList.length === 0) {
                this.positionData.workflowData.requestFeedback.added.resultList = (talentIds || []).map(talentId => ({ talentId }));
                this.positionData.workflowData.requestFeedback.added.resultListLength = total;
            }

            for (let i = 0; i < candidates.length; i++) {
                this.positionData.workflowData.requestFeedback.added.resultList[pageOptions.page * pageOptions.size + i] = candidates[i];
            }

            this.candidatesWithFeedback.push(...candidates);
            this.canFetchMoreFeedbackCandidates = this.candidatesWithFeedback.length < this.feedbackListPageOptions.total;

            this.populateFeedbackCandidatesWithExplain(_.map(candidates, 'talentID'));
            this.filteredCandidatesList = this.getFilteredCandidatesList();
        } catch (error) {
            Logger.error(error);
        } finally {
            this.isFeedbackCandidatesLoading = false;
            this.$scope.$apply();
        }
    }

    async populateFeedbackCandidatesWithExplain(talentIDs) {
        const chunkedTalentIds = _.chunk(talentIDs, TALENTS_EXPLAIN_CHUNK_SIZE);

        this.positionData.workflowData.requestFeedback.added.resultList.forEach((candidate) => {
            if (talentIDs.includes(candidate.talentID)) {
                candidate.isExplainLoading = true;
            }
        });

        const isProfileView = this.currentTalentID;

        for (const oneChunk of chunkedTalentIds) {
            const { result: talentExplains = [] } = await this.TalentScoreService.postTalentExplainScore({
                filter: {
                    ...this.positionData.desiredCandidateProfile,
                    explainInDetails: isProfileView ? ExplainInDetailsLevel.full : ExplainInDetailsLevel.minimalWithSkills,
                },
                talentIDs: oneChunk,
            });
            this.positionData.workflowData.requestFeedback.added.resultList = this.CandidateService.addExplainsDataToCandidates({
                candidates: this.positionData.workflowData.requestFeedback.added.resultList,
                talentExplains,
            });

            this.positionData.workflowData.requestFeedback.added.resultList.forEach((candidate) => {
                if (oneChunk.includes(candidate.talentID)) {
                    candidate.isExplainLoading = false;
                }
            });

            this.$scope.$apply();
        }
    }

    openBulkClaimPopup() {
        const isFeedbackTab = this.workflow === RECRUITER_WORKFLOW_STATUS.FEEDBACK;

        const candidates = isFeedbackTab ? this.candidatesWithFeedback : this.filteredCandidatesList;

        const modalInstance = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'shared/modals/bulkClaimPopup/template.html',
            controller: 'bulkClaimPopupCtrl',
            controllerAs: 'ctrl',
            windowClass: 'bulk-claim',
            backdrop: 'static',
            size: 'md',
            resolve: {
                data: () => ({
                    candidates,
                    recruiterId: this.currentRecruiterId,
                }),
                onSubmit: () => this.onBulkClaim.bind(this),
            },
        });
        modalInstance.result.then(() => {
        }, () => {
        });
    }

    async onBulkClaim(candidates) {
        try {
            const response = await this.bulkClaimCandidates({ candidates });
            const result = _.get(response, 'result');
            if (result === 'ok') {
                this.NotificationService.success('CANDIDATES_HAVE_BEEN_CLAIMED');
            } else {
                this.NotificationService.error('CANDIDATES_CLAIM_ERROR');
            }
            this.$state.reload();
        } catch (error) {
            Logger.error(error);
            this.NotificationService.error('CANDIDATES_CLAIM_ERROR');
        }
    }
}

export const RecruiterCandidatesJobComponentConfiguration = {
    template,
    require: {
        recruiterCtrl: '^recruiterComponent',
    },
    controller: RecruiterCandidatesJobController,
    controllerAs: 'recruiterCandidatesJobCtrl',
};

angular
    .module('TALENYA-FE')
    .component('recruiterCandidatesJobComponent', RecruiterCandidatesJobComponentConfiguration);
